var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __pow = Math.pow;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from4, except, desc) => {
  if (from4 && typeof from4 === "object" || typeof from4 === "function") {
    for (let key of __getOwnPropNames(from4))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from4[key], enumerable: !(desc = __getOwnPropDesc(from4, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target, mod));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// ../node_modules/@stablelib/int/lib/int.js
var require_int = __commonJS({
  "../node_modules/@stablelib/int/lib/int.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function imulShim(a, b) {
      var ah = a >>> 16 & 65535, al = a & 65535;
      var bh = b >>> 16 & 65535, bl = b & 65535;
      return al * bl + (ah * bl + al * bh << 16 >>> 0) | 0;
    }
    exports.mul = Math.imul || imulShim;
    function add(a, b) {
      return a + b | 0;
    }
    exports.add = add;
    function sub(a, b) {
      return a - b | 0;
    }
    exports.sub = sub;
    function rotl(x, n) {
      return x << n | x >>> 32 - n;
    }
    exports.rotl = rotl;
    function rotr(x, n) {
      return x << 32 - n | x >>> n;
    }
    exports.rotr = rotr;
    function isIntegerShim(n) {
      return typeof n === "number" && isFinite(n) && Math.floor(n) === n;
    }
    exports.isInteger = Number.isInteger || isIntegerShim;
    exports.MAX_SAFE_INTEGER = 9007199254740991;
    exports.isSafeInteger = function(n) {
      return exports.isInteger(n) && (n >= -exports.MAX_SAFE_INTEGER && n <= exports.MAX_SAFE_INTEGER);
    };
  }
});

// ../node_modules/@stablelib/binary/lib/binary.js
var require_binary = __commonJS({
  "../node_modules/@stablelib/binary/lib/binary.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var int_1 = require_int();
    function readInt16BE(array, offset) {
      if (offset === void 0) {
        offset = 0;
      }
      return (array[offset + 0] << 8 | array[offset + 1]) << 16 >> 16;
    }
    exports.readInt16BE = readInt16BE;
    function readUint16BE(array, offset) {
      if (offset === void 0) {
        offset = 0;
      }
      return (array[offset + 0] << 8 | array[offset + 1]) >>> 0;
    }
    exports.readUint16BE = readUint16BE;
    function readInt16LE(array, offset) {
      if (offset === void 0) {
        offset = 0;
      }
      return (array[offset + 1] << 8 | array[offset]) << 16 >> 16;
    }
    exports.readInt16LE = readInt16LE;
    function readUint16LE(array, offset) {
      if (offset === void 0) {
        offset = 0;
      }
      return (array[offset + 1] << 8 | array[offset]) >>> 0;
    }
    exports.readUint16LE = readUint16LE;
    function writeUint16BE(value, out, offset) {
      if (out === void 0) {
        out = new Uint8Array(2);
      }
      if (offset === void 0) {
        offset = 0;
      }
      out[offset + 0] = value >>> 8;
      out[offset + 1] = value >>> 0;
      return out;
    }
    exports.writeUint16BE = writeUint16BE;
    exports.writeInt16BE = writeUint16BE;
    function writeUint16LE(value, out, offset) {
      if (out === void 0) {
        out = new Uint8Array(2);
      }
      if (offset === void 0) {
        offset = 0;
      }
      out[offset + 0] = value >>> 0;
      out[offset + 1] = value >>> 8;
      return out;
    }
    exports.writeUint16LE = writeUint16LE;
    exports.writeInt16LE = writeUint16LE;
    function readInt32BE(array, offset) {
      if (offset === void 0) {
        offset = 0;
      }
      return array[offset] << 24 | array[offset + 1] << 16 | array[offset + 2] << 8 | array[offset + 3];
    }
    exports.readInt32BE = readInt32BE;
    function readUint32BE(array, offset) {
      if (offset === void 0) {
        offset = 0;
      }
      return (array[offset] << 24 | array[offset + 1] << 16 | array[offset + 2] << 8 | array[offset + 3]) >>> 0;
    }
    exports.readUint32BE = readUint32BE;
    function readInt32LE(array, offset) {
      if (offset === void 0) {
        offset = 0;
      }
      return array[offset + 3] << 24 | array[offset + 2] << 16 | array[offset + 1] << 8 | array[offset];
    }
    exports.readInt32LE = readInt32LE;
    function readUint32LE(array, offset) {
      if (offset === void 0) {
        offset = 0;
      }
      return (array[offset + 3] << 24 | array[offset + 2] << 16 | array[offset + 1] << 8 | array[offset]) >>> 0;
    }
    exports.readUint32LE = readUint32LE;
    function writeUint32BE(value, out, offset) {
      if (out === void 0) {
        out = new Uint8Array(4);
      }
      if (offset === void 0) {
        offset = 0;
      }
      out[offset + 0] = value >>> 24;
      out[offset + 1] = value >>> 16;
      out[offset + 2] = value >>> 8;
      out[offset + 3] = value >>> 0;
      return out;
    }
    exports.writeUint32BE = writeUint32BE;
    exports.writeInt32BE = writeUint32BE;
    function writeUint32LE(value, out, offset) {
      if (out === void 0) {
        out = new Uint8Array(4);
      }
      if (offset === void 0) {
        offset = 0;
      }
      out[offset + 0] = value >>> 0;
      out[offset + 1] = value >>> 8;
      out[offset + 2] = value >>> 16;
      out[offset + 3] = value >>> 24;
      return out;
    }
    exports.writeUint32LE = writeUint32LE;
    exports.writeInt32LE = writeUint32LE;
    function readInt64BE(array, offset) {
      if (offset === void 0) {
        offset = 0;
      }
      var hi = readInt32BE(array, offset);
      var lo = readInt32BE(array, offset + 4);
      return hi * 4294967296 + lo - (lo >> 31) * 4294967296;
    }
    exports.readInt64BE = readInt64BE;
    function readUint64BE(array, offset) {
      if (offset === void 0) {
        offset = 0;
      }
      var hi = readUint32BE(array, offset);
      var lo = readUint32BE(array, offset + 4);
      return hi * 4294967296 + lo;
    }
    exports.readUint64BE = readUint64BE;
    function readInt64LE(array, offset) {
      if (offset === void 0) {
        offset = 0;
      }
      var lo = readInt32LE(array, offset);
      var hi = readInt32LE(array, offset + 4);
      return hi * 4294967296 + lo - (lo >> 31) * 4294967296;
    }
    exports.readInt64LE = readInt64LE;
    function readUint64LE(array, offset) {
      if (offset === void 0) {
        offset = 0;
      }
      var lo = readUint32LE(array, offset);
      var hi = readUint32LE(array, offset + 4);
      return hi * 4294967296 + lo;
    }
    exports.readUint64LE = readUint64LE;
    function writeUint64BE(value, out, offset) {
      if (out === void 0) {
        out = new Uint8Array(8);
      }
      if (offset === void 0) {
        offset = 0;
      }
      writeUint32BE(value / 4294967296 >>> 0, out, offset);
      writeUint32BE(value >>> 0, out, offset + 4);
      return out;
    }
    exports.writeUint64BE = writeUint64BE;
    exports.writeInt64BE = writeUint64BE;
    function writeUint64LE(value, out, offset) {
      if (out === void 0) {
        out = new Uint8Array(8);
      }
      if (offset === void 0) {
        offset = 0;
      }
      writeUint32LE(value >>> 0, out, offset);
      writeUint32LE(value / 4294967296 >>> 0, out, offset + 4);
      return out;
    }
    exports.writeUint64LE = writeUint64LE;
    exports.writeInt64LE = writeUint64LE;
    function readUintBE(bitLength, array, offset) {
      if (offset === void 0) {
        offset = 0;
      }
      if (bitLength % 8 !== 0) {
        throw new Error("readUintBE supports only bitLengths divisible by 8");
      }
      if (bitLength / 8 > array.length - offset) {
        throw new Error("readUintBE: array is too short for the given bitLength");
      }
      var result = 0;
      var mul = 1;
      for (var i = bitLength / 8 + offset - 1; i >= offset; i--) {
        result += array[i] * mul;
        mul *= 256;
      }
      return result;
    }
    exports.readUintBE = readUintBE;
    function readUintLE(bitLength, array, offset) {
      if (offset === void 0) {
        offset = 0;
      }
      if (bitLength % 8 !== 0) {
        throw new Error("readUintLE supports only bitLengths divisible by 8");
      }
      if (bitLength / 8 > array.length - offset) {
        throw new Error("readUintLE: array is too short for the given bitLength");
      }
      var result = 0;
      var mul = 1;
      for (var i = offset; i < offset + bitLength / 8; i++) {
        result += array[i] * mul;
        mul *= 256;
      }
      return result;
    }
    exports.readUintLE = readUintLE;
    function writeUintBE(bitLength, value, out, offset) {
      if (out === void 0) {
        out = new Uint8Array(bitLength / 8);
      }
      if (offset === void 0) {
        offset = 0;
      }
      if (bitLength % 8 !== 0) {
        throw new Error("writeUintBE supports only bitLengths divisible by 8");
      }
      if (!int_1.isSafeInteger(value)) {
        throw new Error("writeUintBE value must be an integer");
      }
      var div = 1;
      for (var i = bitLength / 8 + offset - 1; i >= offset; i--) {
        out[i] = value / div & 255;
        div *= 256;
      }
      return out;
    }
    exports.writeUintBE = writeUintBE;
    function writeUintLE(bitLength, value, out, offset) {
      if (out === void 0) {
        out = new Uint8Array(bitLength / 8);
      }
      if (offset === void 0) {
        offset = 0;
      }
      if (bitLength % 8 !== 0) {
        throw new Error("writeUintLE supports only bitLengths divisible by 8");
      }
      if (!int_1.isSafeInteger(value)) {
        throw new Error("writeUintLE value must be an integer");
      }
      var div = 1;
      for (var i = offset; i < offset + bitLength / 8; i++) {
        out[i] = value / div & 255;
        div *= 256;
      }
      return out;
    }
    exports.writeUintLE = writeUintLE;
    function readFloat32BE(array, offset) {
      if (offset === void 0) {
        offset = 0;
      }
      var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
      return view.getFloat32(offset);
    }
    exports.readFloat32BE = readFloat32BE;
    function readFloat32LE(array, offset) {
      if (offset === void 0) {
        offset = 0;
      }
      var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
      return view.getFloat32(offset, true);
    }
    exports.readFloat32LE = readFloat32LE;
    function readFloat64BE(array, offset) {
      if (offset === void 0) {
        offset = 0;
      }
      var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
      return view.getFloat64(offset);
    }
    exports.readFloat64BE = readFloat64BE;
    function readFloat64LE(array, offset) {
      if (offset === void 0) {
        offset = 0;
      }
      var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
      return view.getFloat64(offset, true);
    }
    exports.readFloat64LE = readFloat64LE;
    function writeFloat32BE(value, out, offset) {
      if (out === void 0) {
        out = new Uint8Array(4);
      }
      if (offset === void 0) {
        offset = 0;
      }
      var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
      view.setFloat32(offset, value);
      return out;
    }
    exports.writeFloat32BE = writeFloat32BE;
    function writeFloat32LE(value, out, offset) {
      if (out === void 0) {
        out = new Uint8Array(4);
      }
      if (offset === void 0) {
        offset = 0;
      }
      var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
      view.setFloat32(offset, value, true);
      return out;
    }
    exports.writeFloat32LE = writeFloat32LE;
    function writeFloat64BE(value, out, offset) {
      if (out === void 0) {
        out = new Uint8Array(8);
      }
      if (offset === void 0) {
        offset = 0;
      }
      var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
      view.setFloat64(offset, value);
      return out;
    }
    exports.writeFloat64BE = writeFloat64BE;
    function writeFloat64LE(value, out, offset) {
      if (out === void 0) {
        out = new Uint8Array(8);
      }
      if (offset === void 0) {
        offset = 0;
      }
      var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
      view.setFloat64(offset, value, true);
      return out;
    }
    exports.writeFloat64LE = writeFloat64LE;
  }
});

// ../node_modules/@stablelib/wipe/lib/wipe.js
var require_wipe = __commonJS({
  "../node_modules/@stablelib/wipe/lib/wipe.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function wipe(array) {
      for (var i = 0; i < array.length; i++) {
        array[i] = 0;
      }
      return array;
    }
    exports.wipe = wipe;
  }
});

// ../node_modules/@stablelib/blake2b/lib/blake2b.js
var require_blake2b = __commonJS({
  "../node_modules/@stablelib/blake2b/lib/blake2b.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var binary_1 = require_binary();
    var wipe_1 = require_wipe();
    exports.BLOCK_SIZE = 128;
    exports.DIGEST_LENGTH = 64;
    exports.KEY_LENGTH = 64;
    exports.PERSONALIZATION_LENGTH = 16;
    exports.SALT_LENGTH = 16;
    exports.MAX_LEAF_SIZE = Math.pow(2, 32) - 1;
    exports.MAX_FANOUT = 255;
    exports.MAX_MAX_DEPTH = 255;
    var IV = new Uint32Array([
      4089235720,
      1779033703,
      2227873595,
      3144134277,
      4271175723,
      1013904242,
      1595750129,
      2773480762,
      2917565137,
      1359893119,
      725511199,
      2600822924,
      4215389547,
      528734635,
      327033209,
      1541459225
    ]);
    var SIGMA = [
      [0, 2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30],
      [28, 20, 8, 16, 18, 30, 26, 12, 2, 24, 0, 4, 22, 14, 10, 6],
      [22, 16, 24, 0, 10, 4, 30, 26, 20, 28, 6, 12, 14, 2, 18, 8],
      [14, 18, 6, 2, 26, 24, 22, 28, 4, 12, 10, 20, 8, 0, 30, 16],
      [18, 0, 10, 14, 4, 8, 20, 30, 28, 2, 22, 24, 12, 16, 6, 26],
      [4, 24, 12, 20, 0, 22, 16, 6, 8, 26, 14, 10, 30, 28, 2, 18],
      [24, 10, 2, 30, 28, 26, 8, 20, 0, 14, 12, 6, 18, 4, 16, 22],
      [26, 22, 14, 28, 24, 2, 6, 18, 10, 0, 30, 8, 16, 12, 4, 20],
      [12, 30, 28, 18, 22, 6, 0, 16, 24, 4, 26, 14, 2, 8, 20, 10],
      [20, 4, 16, 8, 14, 12, 2, 10, 30, 22, 18, 28, 6, 24, 26, 0],
      [0, 2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30],
      [28, 20, 8, 16, 18, 30, 26, 12, 2, 24, 0, 4, 22, 14, 10, 6]
    ];
    var BLAKE2b = function() {
      function BLAKE2b2(digestLength, config) {
        if (digestLength === void 0) {
          digestLength = 64;
        }
        this.digestLength = digestLength;
        this.blockSize = exports.BLOCK_SIZE;
        this._state = new Int32Array(IV);
        this._buffer = new Uint8Array(exports.BLOCK_SIZE);
        this._bufferLength = 0;
        this._ctr = new Uint32Array(4);
        this._flag = new Uint32Array(4);
        this._lastNode = false;
        this._finished = false;
        this._vtmp = new Uint32Array(32);
        this._mtmp = new Uint32Array(32);
        if (digestLength < 1 || digestLength > exports.DIGEST_LENGTH) {
          throw new Error("blake2b: wrong digest length");
        }
        if (config) {
          this.validateConfig(config);
        }
        var keyLength = 0;
        if (config && config.key) {
          keyLength = config.key.length;
        }
        var fanout = 1;
        var maxDepth = 1;
        if (config && config.tree) {
          fanout = config.tree.fanout;
          maxDepth = config.tree.maxDepth;
        }
        this._state[0] ^= digestLength | keyLength << 8 | fanout << 16 | maxDepth << 24;
        if (config && config.tree) {
          this._state[1] ^= config.tree.leafSize;
          this._state[2] ^= config.tree.nodeOffsetLowBits;
          this._state[3] ^= config.tree.nodeOffsetHighBits;
          this._state[4] ^= config.tree.nodeDepth | config.tree.innerDigestLength << 8;
          this._lastNode = config.tree.lastNode;
        }
        if (config && config.salt) {
          this._state[8] ^= binary_1.readUint32LE(config.salt, 0);
          this._state[9] ^= binary_1.readUint32LE(config.salt, 4);
          this._state[10] ^= binary_1.readUint32LE(config.salt, 8);
          this._state[11] ^= binary_1.readUint32LE(config.salt, 12);
        }
        if (config && config.personalization) {
          this._state[12] ^= binary_1.readUint32LE(config.personalization, 0);
          this._state[13] ^= binary_1.readUint32LE(config.personalization, 4);
          this._state[14] ^= binary_1.readUint32LE(config.personalization, 8);
          this._state[15] ^= binary_1.readUint32LE(config.personalization, 12);
        }
        this._initialState = new Uint32Array(this._state);
        if (config && config.key && keyLength > 0) {
          this._paddedKey = new Uint8Array(exports.BLOCK_SIZE);
          this._paddedKey.set(config.key);
          this._buffer.set(this._paddedKey);
          this._bufferLength = exports.BLOCK_SIZE;
        }
      }
      BLAKE2b2.prototype.reset = function() {
        this._state.set(this._initialState);
        if (this._paddedKey) {
          this._buffer.set(this._paddedKey);
          this._bufferLength = exports.BLOCK_SIZE;
        } else {
          this._bufferLength = 0;
        }
        wipe_1.wipe(this._ctr);
        wipe_1.wipe(this._flag);
        this._finished = false;
        return this;
      };
      BLAKE2b2.prototype.validateConfig = function(config) {
        if (config.key && config.key.length > exports.KEY_LENGTH) {
          throw new Error("blake2b: wrong key length");
        }
        if (config.salt && config.salt.length !== exports.SALT_LENGTH) {
          throw new Error("blake2b: wrong salt length");
        }
        if (config.personalization && config.personalization.length !== exports.PERSONALIZATION_LENGTH) {
          throw new Error("blake2b: wrong personalization length");
        }
        if (config.tree) {
          if (config.tree.fanout < 0 || config.tree.fanout > exports.MAX_FANOUT) {
            throw new Error("blake2b: wrong tree fanout");
          }
          if (config.tree.maxDepth < 0 || config.tree.maxDepth > exports.MAX_MAX_DEPTH) {
            throw new Error("blake2b: wrong tree depth");
          }
          if (config.tree.leafSize < 0 || config.tree.leafSize > exports.MAX_LEAF_SIZE) {
            throw new Error("blake2b: wrong leaf size");
          }
          if (config.tree.innerDigestLength < 0 || config.tree.innerDigestLength > exports.DIGEST_LENGTH) {
            throw new Error("blake2b: wrong tree inner digest length");
          }
        }
      };
      BLAKE2b2.prototype.update = function(data, dataLength) {
        if (dataLength === void 0) {
          dataLength = data.length;
        }
        if (this._finished) {
          throw new Error("blake2b: can't update because hash was finished.");
        }
        var left = exports.BLOCK_SIZE - this._bufferLength;
        var dataPos = 0;
        if (dataLength === 0) {
          return this;
        }
        if (dataLength > left) {
          for (var i = 0; i < left; i++) {
            this._buffer[this._bufferLength + i] = data[dataPos + i];
          }
          this._processBlock(exports.BLOCK_SIZE);
          dataPos += left;
          dataLength -= left;
          this._bufferLength = 0;
        }
        while (dataLength > exports.BLOCK_SIZE) {
          for (var i = 0; i < exports.BLOCK_SIZE; i++) {
            this._buffer[i] = data[dataPos + i];
          }
          this._processBlock(exports.BLOCK_SIZE);
          dataPos += exports.BLOCK_SIZE;
          dataLength -= exports.BLOCK_SIZE;
          this._bufferLength = 0;
        }
        for (var i = 0; i < dataLength; i++) {
          this._buffer[this._bufferLength + i] = data[dataPos + i];
        }
        this._bufferLength += dataLength;
        return this;
      };
      BLAKE2b2.prototype.finish = function(out) {
        if (!this._finished) {
          for (var i = this._bufferLength; i < exports.BLOCK_SIZE; i++) {
            this._buffer[i] = 0;
          }
          this._flag[0] = 4294967295;
          this._flag[1] = 4294967295;
          if (this._lastNode) {
            this._flag[2] = 4294967295;
            this._flag[3] = 4294967295;
          }
          this._processBlock(this._bufferLength);
          this._finished = true;
        }
        var tmp = this._buffer.subarray(0, 64);
        for (var i = 0; i < 16; i++) {
          binary_1.writeUint32LE(this._state[i], tmp, i * 4);
        }
        out.set(tmp.subarray(0, out.length));
        return this;
      };
      BLAKE2b2.prototype.digest = function() {
        var out = new Uint8Array(this.digestLength);
        this.finish(out);
        return out;
      };
      BLAKE2b2.prototype.clean = function() {
        wipe_1.wipe(this._vtmp);
        wipe_1.wipe(this._mtmp);
        wipe_1.wipe(this._state);
        wipe_1.wipe(this._buffer);
        wipe_1.wipe(this._initialState);
        if (this._paddedKey) {
          wipe_1.wipe(this._paddedKey);
        }
        this._bufferLength = 0;
        wipe_1.wipe(this._ctr);
        wipe_1.wipe(this._flag);
        this._lastNode = false;
        this._finished = false;
      };
      BLAKE2b2.prototype.saveState = function() {
        if (this._finished) {
          throw new Error("blake2b: cannot save finished state");
        }
        return {
          state: new Uint32Array(this._state),
          buffer: new Uint8Array(this._buffer),
          bufferLength: this._bufferLength,
          ctr: new Uint32Array(this._ctr),
          flag: new Uint32Array(this._flag),
          lastNode: this._lastNode,
          paddedKey: this._paddedKey ? new Uint8Array(this._paddedKey) : void 0,
          initialState: new Uint32Array(this._initialState)
        };
      };
      BLAKE2b2.prototype.restoreState = function(savedState) {
        this._state.set(savedState.state);
        this._buffer.set(savedState.buffer);
        this._bufferLength = savedState.bufferLength;
        this._ctr.set(savedState.ctr);
        this._flag.set(savedState.flag);
        this._lastNode = savedState.lastNode;
        if (this._paddedKey) {
          wipe_1.wipe(this._paddedKey);
        }
        this._paddedKey = savedState.paddedKey ? new Uint8Array(savedState.paddedKey) : void 0;
        this._initialState.set(savedState.initialState);
        return this;
      };
      BLAKE2b2.prototype.cleanSavedState = function(savedState) {
        wipe_1.wipe(savedState.state);
        wipe_1.wipe(savedState.buffer);
        wipe_1.wipe(savedState.initialState);
        if (savedState.paddedKey) {
          wipe_1.wipe(savedState.paddedKey);
        }
        savedState.bufferLength = 0;
        wipe_1.wipe(savedState.ctr);
        wipe_1.wipe(savedState.flag);
        savedState.lastNode = false;
      };
      BLAKE2b2.prototype._G = function(v, al, bl, cl, dl, ah, bh, ch, dh, ml0, mh0, ml1, mh1) {
        var vla = v[al], vha = v[ah], vlb = v[bl], vhb = v[bh], vlc = v[cl], vhc = v[ch], vld = v[dl], vhd = v[dh];
        var w = vla & 65535, x = vla >>> 16, y = vha & 65535, z = vha >>> 16;
        w += vlb & 65535;
        x += vlb >>> 16;
        y += vhb & 65535;
        z += vhb >>> 16;
        x += w >>> 16;
        y += x >>> 16;
        z += y >>> 16;
        vha = y & 65535 | z << 16;
        vla = w & 65535 | x << 16;
        w = vla & 65535;
        x = vla >>> 16;
        y = vha & 65535;
        z = vha >>> 16;
        w += ml0 & 65535;
        x += ml0 >>> 16;
        y += mh0 & 65535;
        z += mh0 >>> 16;
        x += w >>> 16;
        y += x >>> 16;
        z += y >>> 16;
        vha = y & 65535 | z << 16;
        vla = w & 65535 | x << 16;
        vld ^= vla;
        vhd ^= vha;
        w = vhd;
        vhd = vld;
        vld = w;
        w = vlc & 65535;
        x = vlc >>> 16;
        y = vhc & 65535;
        z = vhc >>> 16;
        w += vld & 65535;
        x += vld >>> 16;
        y += vhd & 65535;
        z += vhd >>> 16;
        x += w >>> 16;
        y += x >>> 16;
        z += y >>> 16;
        vhc = y & 65535 | z << 16;
        vlc = w & 65535 | x << 16;
        vlb ^= vlc;
        vhb ^= vhc;
        w = vlb << 8 | vhb >>> 24;
        vlb = vhb << 8 | vlb >>> 24;
        vhb = w;
        w = vla & 65535;
        x = vla >>> 16;
        y = vha & 65535;
        z = vha >>> 16;
        w += vlb & 65535;
        x += vlb >>> 16;
        y += vhb & 65535;
        z += vhb >>> 16;
        x += w >>> 16;
        y += x >>> 16;
        z += y >>> 16;
        vha = y & 65535 | z << 16;
        vla = w & 65535 | x << 16;
        w = vla & 65535;
        x = vla >>> 16;
        y = vha & 65535;
        z = vha >>> 16;
        w += ml1 & 65535;
        x += ml1 >>> 16;
        y += mh1 & 65535;
        z += mh1 >>> 16;
        x += w >>> 16;
        y += x >>> 16;
        z += y >>> 16;
        vha = y & 65535 | z << 16;
        vla = w & 65535 | x << 16;
        vld ^= vla;
        vhd ^= vha;
        w = vld << 16 | vhd >>> 16;
        vld = vhd << 16 | vld >>> 16;
        vhd = w;
        w = vlc & 65535;
        x = vlc >>> 16;
        y = vhc & 65535;
        z = vhc >>> 16;
        w += vld & 65535;
        x += vld >>> 16;
        y += vhd & 65535;
        z += vhd >>> 16;
        x += w >>> 16;
        y += x >>> 16;
        z += y >>> 16;
        vhc = y & 65535 | z << 16;
        vlc = w & 65535 | x << 16;
        vlb ^= vlc;
        vhb ^= vhc;
        w = vhb << 1 | vlb >>> 31;
        vlb = vlb << 1 | vhb >>> 31;
        vhb = w;
        v[al] = vla;
        v[ah] = vha;
        v[bl] = vlb;
        v[bh] = vhb;
        v[cl] = vlc;
        v[ch] = vhc;
        v[dl] = vld;
        v[dh] = vhd;
      };
      BLAKE2b2.prototype._incrementCounter = function(n) {
        for (var i = 0; i < 3; i++) {
          var a = this._ctr[i] + n;
          this._ctr[i] = a >>> 0;
          if (this._ctr[i] === a) {
            return;
          }
          n = 1;
        }
      };
      BLAKE2b2.prototype._processBlock = function(length) {
        this._incrementCounter(length);
        var v = this._vtmp;
        v.set(this._state);
        v.set(IV, 16);
        v[12 * 2 + 0] ^= this._ctr[0];
        v[12 * 2 + 1] ^= this._ctr[1];
        v[13 * 2 + 0] ^= this._ctr[2];
        v[13 * 2 + 1] ^= this._ctr[3];
        v[14 * 2 + 0] ^= this._flag[0];
        v[14 * 2 + 1] ^= this._flag[1];
        v[15 * 2 + 0] ^= this._flag[2];
        v[15 * 2 + 1] ^= this._flag[3];
        var m = this._mtmp;
        for (var i = 0; i < 32; i++) {
          m[i] = binary_1.readUint32LE(this._buffer, i * 4);
        }
        for (var r = 0; r < 12; r++) {
          this._G(v, 0, 8, 16, 24, 1, 9, 17, 25, m[SIGMA[r][0]], m[SIGMA[r][0] + 1], m[SIGMA[r][1]], m[SIGMA[r][1] + 1]);
          this._G(v, 2, 10, 18, 26, 3, 11, 19, 27, m[SIGMA[r][2]], m[SIGMA[r][2] + 1], m[SIGMA[r][3]], m[SIGMA[r][3] + 1]);
          this._G(v, 4, 12, 20, 28, 5, 13, 21, 29, m[SIGMA[r][4]], m[SIGMA[r][4] + 1], m[SIGMA[r][5]], m[SIGMA[r][5] + 1]);
          this._G(v, 6, 14, 22, 30, 7, 15, 23, 31, m[SIGMA[r][6]], m[SIGMA[r][6] + 1], m[SIGMA[r][7]], m[SIGMA[r][7] + 1]);
          this._G(v, 0, 10, 20, 30, 1, 11, 21, 31, m[SIGMA[r][8]], m[SIGMA[r][8] + 1], m[SIGMA[r][9]], m[SIGMA[r][9] + 1]);
          this._G(v, 2, 12, 22, 24, 3, 13, 23, 25, m[SIGMA[r][10]], m[SIGMA[r][10] + 1], m[SIGMA[r][11]], m[SIGMA[r][11] + 1]);
          this._G(v, 4, 14, 16, 26, 5, 15, 17, 27, m[SIGMA[r][12]], m[SIGMA[r][12] + 1], m[SIGMA[r][13]], m[SIGMA[r][13] + 1]);
          this._G(v, 6, 8, 18, 28, 7, 9, 19, 29, m[SIGMA[r][14]], m[SIGMA[r][14] + 1], m[SIGMA[r][15]], m[SIGMA[r][15] + 1]);
        }
        for (var i = 0; i < 16; i++) {
          this._state[i] ^= v[i] ^ v[i + 16];
        }
      };
      return BLAKE2b2;
    }();
    exports.BLAKE2b = BLAKE2b;
    function hash2(data, digestLength, config) {
      if (digestLength === void 0) {
        digestLength = exports.DIGEST_LENGTH;
      }
      var h = new BLAKE2b(digestLength, config);
      h.update(data);
      var digest = h.digest();
      h.clean();
      return digest;
    }
    exports.hash = hash2;
  }
});

// ../node_modules/@polkadot/util/is/hex.js
var REGEX_HEX_PREFIXED = /^0x[\da-fA-F]+$/;
var REGEX_HEX_NOPREFIX = /^[\da-fA-F]+$/;

// ../node_modules/@polkadot/util/bn/bn.js
import BN from "bn.js";

// ../node_modules/@polkadot/util/is/boolean.js
function isBoolean(value) {
  return typeof value === "boolean";
}

// ../node_modules/@polkadot/util/hex/stripPrefix.js
function hexStripPrefix(value) {
  if (!value || value === "0x") {
    return "";
  } else if (REGEX_HEX_PREFIXED.test(value)) {
    return value.substring(2);
  } else if (REGEX_HEX_NOPREFIX.test(value)) {
    return value;
  }
  throw new Error(`Expected hex value to convert, found '${value}'`);
}

// ../node_modules/@polkadot/util/hex/toBn.js
function hexToBn(value, options = {}) {
  if (!value || value === "0x") {
    return new BN(0);
  }
  const {
    isLe = false,
    isNegative = false
  } = isBoolean(options) ? {
    isLe: options
  } : options;
  const stripped = hexStripPrefix(value);
  const bn = new BN(stripped, 16, isLe ? "le" : "be");
  return isNegative ? bn.fromTwos(stripped.length * 4) : bn;
}

// src/CentrifugeBase.ts
import "isomorphic-fetch";
import {
  bufferCount,
  catchError,
  combineLatest,
  combineLatestWith,
  filter,
  firstValueFrom,
  from,
  lastValueFrom,
  map,
  mergeWith,
  of,
  share,
  startWith,
  Subject,
  switchMap,
  take,
  takeWhile,
  tap,
  throwError
} from "rxjs";
import { fromFetch } from "rxjs/fetch";

// src/utils/BN.ts
import BN2 from "bn.js";

// src/utils/Decimal.ts
import Decimal from "decimal.js-light";
Decimal.set({
  precision: 30,
  toExpNeg: -7,
  toExpPos: 29,
  rounding: Decimal.ROUND_HALF_CEIL
});
function Dec(value) {
  return new Decimal(value);
}

// src/utils/BN.ts
var BNSubType = class extends BN2 {
  static _fromFloat(number) {
    const n = Dec(number).mul(Dec(10).pow(this.decimals)).toDecimalPlaces(0).toString();
    return new this(n);
  }
  constructor(number) {
    super(BN2.isBN(number) ? number.toString() : number);
  }
  getDecimals() {
    return this.constructor.decimals;
  }
  toDecimal() {
    return Dec(this.toString()).div(Dec(10).pow(this.getDecimals()));
  }
  toFloat() {
    return this.toDecimal().toNumber();
  }
};
var CurrencyBalance = class extends BN2 {
  constructor(number, decimals) {
    super(BN2.isBN(number) ? number.toString() : number);
    this.decimals = decimals;
  }
  static fromFloat(number, decimals) {
    const n = Dec(number).mul(Dec(10).pow(decimals)).toDecimalPlaces(0).toString();
    return new CurrencyBalance(n, decimals);
  }
  toDecimal() {
    return Dec(this.toString()).div(Dec(10).pow(this.decimals));
  }
  toFloat() {
    return this.toDecimal().toNumber();
  }
};
var TokenBalance = class extends CurrencyBalance {
  static fromFloat(number, decimals) {
    const n = Dec(number).mul(Dec(10).pow(decimals)).toDecimalPlaces(0).toString();
    return new TokenBalance(n, decimals);
  }
};
var _Price = class extends BNSubType {
  static fromFloat(number) {
    return _Price._fromFloat(number);
  }
};
var Price = _Price;
Price.decimals = 27;
var _Perquintill = class extends BNSubType {
  static fromFloat(number) {
    return _Perquintill._fromFloat(number);
  }
  static fromPercent(number) {
    return _Perquintill.fromFloat(Dec(number).div(100));
  }
  toPercent() {
    return this.toDecimal().mul(100);
  }
};
var Perquintill = _Perquintill;
Perquintill.decimals = 18;
var secondsPerYear = Dec(60 * 60 * 24 * 365);
var _Rate = class extends BNSubType {
  static fromFloat(number) {
    return _Rate._fromFloat(number);
  }
  static fromPercent(number) {
    return _Rate.fromFloat(Dec(number).div(100));
  }
  static fromApr(apr) {
    const i = Dec(apr);
    const rate = i.div(secondsPerYear).plus(1);
    return _Rate.fromFloat(rate);
  }
  static fromAprPercent(apr) {
    return this.fromApr(Dec(apr).div(100));
  }
  toPercent() {
    return this.toDecimal().mul(100);
  }
  toApr() {
    const rate = this.toDecimal();
    if (rate.isZero()) {
      return rate;
    }
    const i = rate.minus(1).times(secondsPerYear);
    return i;
  }
  toAprPercent() {
    return this.toApr().mul(100);
  }
};
var Rate = _Rate;
Rate.decimals = 27;

// src/utils/web3.ts
import { ApiRx, WsProvider } from "@polkadot/api";
var cached = {};
function getPolkadotApi(wsUrl, types, rpc) {
  return cached[wsUrl] || (cached[wsUrl] = ApiRx.create({
    provider: new WsProvider(wsUrl),
    types,
    rpc
  }));
}

// src/CentrifugeBase.ts
var defaultConfig = {
  network: "centrifuge",
  centrifugeWsUrl: "wss://fullnode.centrifuge.io",
  altairWsUrl: "wss://fullnode.altair.centrifuge.io",
  polkadotWsUrl: "wss://rpc.polkadot.io",
  kusamaWsUrl: "wss://kusama-rpc.polkadot.io",
  centrifugeSubqueryUrl: "https://api.subquery.network/sq/centrifuge/pools",
  altairSubqueryUrl: "https://api.subquery.network/sq/centrifuge/pools-altair",
  metadataHost: "https://altair.mypinata.cloud"
};
var relayChainTypes = {};
var parachainTypes = {
  ClassId: "u64",
  InstanceId: "u128"
};
var parachainRpcMethods = {
  pools: {
    trancheTokenPrices: {
      description: "Retrieve prices for all tranches",
      params: [
        {
          name: "pool_id",
          type: "u64"
        }
      ],
      type: "Vec<u128>"
    }
  }
};
var txCompletedEvents = {};
var blockEvents = {};
var CentrifugeBase = class {
  constructor(config = {}) {
    this.config = __spreadValues(__spreadValues({}, defaultConfig), config);
    this.parachainUrl = this.config.network === "centrifuge" ? this.config.centrifugeWsUrl : this.config.altairWsUrl;
    this.relayChainUrl = this.config.network === "centrifuge" ? this.config.polkadotWsUrl : this.config.kusamaWsUrl;
    this.subqueryUrl = this.config.network === "centrifuge" ? this.config.centrifugeSubqueryUrl : this.config.altairSubqueryUrl;
  }
  getChainId() {
    return this.config.network === "centrifuge" ? 36 : 136;
  }
  wrapSignAndSend(api, submittable, options) {
    if (options == null ? void 0 : options.batch)
      return of(submittable);
    if (this.config.printExtrinsics) {
      if (submittable.method.method === "batchAll" || submittable.method.method === "batch") {
        console.log(`utility.${submittable.method.method}([`);
        submittable.method.args[0].forEach((call) => {
          const callDetails = api.findCall(call.callIndex);
          console.log(`	${callDetails.section}.${callDetails.method}(${call.args.map((arg) => arg.toString()).join(", ")})`);
        });
        console.log(`])`);
      } else {
        console.log(`${submittable.method.section}.${submittable.method.method}(${submittable.method.args.map((arg) => arg.toString()).join(", ")})`);
      }
    }
    const { signer, signingAddress } = this.getSigner();
    try {
      let actualSubmittable = submittable;
      if (this.config.proxy) {
        actualSubmittable = api.tx.proxy.proxy(this.config.proxy, void 0, submittable);
      }
      const $paymentInfo = submittable.paymentInfo(signingAddress);
      const $balances = api.query.system.account(signingAddress);
      if (options == null ? void 0 : options.paymentInfo) {
        return lastValueFrom($paymentInfo.pipe(map((paymentInfoRaw) => {
          const paymentInfo = paymentInfoRaw.toJSON();
          return __spreadProps(__spreadValues({}, paymentInfo), {
            partialFee: new CurrencyBalance(paymentInfo.partialFee, api.registry.chainDecimals[0])
          });
        })));
      }
      return combineLatest([$balances, $paymentInfo]).pipe(take(1), takeWhile(([balancesRaw, paymentInfoRaw]) => {
        const paymentInfo = paymentInfoRaw.toJSON();
        const nativeBalance = balancesRaw.toJSON();
        const txFee = Number(paymentInfo.partialFee.toString()) / __pow(10, api.registry.chainDecimals[0]);
        const balance = new CurrencyBalance(hexToBn(nativeBalance.data.free), api.registry.chainDecimals[0]);
        if (balance.lten(txFee)) {
          throw new Error(`${api.registry.chainTokens[0]} balance too low`);
        }
        return true;
      })).pipe(switchMap(() => actualSubmittable.signAndSend(signingAddress, { signer }).pipe(tap((result) => {
        var _a;
        (_a = options == null ? void 0 : options.onStatusChange) == null ? void 0 : _a.call(options, result);
        if (result.status.isInBlock)
          this.getTxCompletedEvents().next(result.events);
      }), takeWhile((result) => {
        const errors = result.events.filter(({ event }) => api.events.system.ExtrinsicFailed.is(event));
        if (errors.length && this.config.debug) {
          console.log("\u{1F6A8} error", JSON.stringify(errors));
        }
        const hasError = !!(result.dispatchError || errors.length);
        return !result.status.isInBlock && !hasError;
      }, true))));
    } catch (e) {
      return throwError(() => e);
    }
  }
  querySubquery(query, variables) {
    return __async(this, null, function* () {
      const res = yield fetch(this.subqueryUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify({ query, variables })
      });
      const { data, errors } = yield res.json();
      if (errors == null ? void 0 : errors.length)
        throw errors;
      return data;
    });
  }
  getSubqueryObservable(query, variables, optional = true) {
    const $ = fromFetch(this.subqueryUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify({ query, variables }),
      selector: (res) => __async(this, null, function* () {
        const { data, errors } = yield res.json();
        if (errors == null ? void 0 : errors.length) {
          if (optional)
            return null;
          throw errors;
        }
        return data;
      })
    });
    if (optional) {
      return $.pipe(startWith(null), catchError(() => of(null)));
    }
    return $;
  }
  getMetadataObservable(url, optional = true) {
    var _a;
    if (((_a = new URL(url)) == null ? void 0 : _a.hostname) !== new URL(this.config.metadataHost).hostname) {
      console.warn("Invalid url");
      return from([]);
    }
    const $ = fromFetch(url);
    if (optional) {
      return $.pipe(startWith(null), catchError(() => of(null)), switchMap((res) => {
        return from((res == null ? void 0 : res.json()) || []);
      }));
    }
    return $.pipe(switchMap((res) => {
      return from(res.json());
    }));
  }
  getBlockEvents() {
    if (blockEvents[this.parachainUrl])
      return blockEvents[this.parachainUrl];
    const $api = this.getApi();
    return blockEvents[this.parachainUrl] = $api.pipe(switchMap((api) => api.queryMulti([api.query.system.events, api.query.system.number]).pipe(bufferCount(2, 1), filter(([[events]]) => !!(events == null ? void 0 : events.length)), map(([[events]]) => events))), share());
  }
  getTxCompletedEvents() {
    return txCompletedEvents[this.parachainUrl] || (txCompletedEvents[this.parachainUrl] = new Subject());
  }
  getEvents() {
    return this.getBlockEvents().pipe(mergeWith(this.getTxCompletedEvents()), combineLatestWith(this.getApi()), map(([events, api]) => ({ events, api })));
  }
  getApi() {
    return getPolkadotApi(this.parachainUrl, parachainTypes, parachainRpcMethods);
  }
  getApiPromise() {
    return firstValueFrom(getPolkadotApi(this.parachainUrl, parachainTypes, parachainRpcMethods));
  }
  getRelayChainApi() {
    return getPolkadotApi(this.relayChainUrl, relayChainTypes);
  }
  getRelayChainApiPromise() {
    return firstValueFrom(getPolkadotApi(this.relayChainUrl, relayChainTypes));
  }
  getBlocks() {
    const $api = this.getApi();
    const $header = $api.pipe(switchMap((api) => api.rpc.chain.subscribeNewHeads()));
    return combineLatest([$api, $header]).pipe(switchMap(([api, header]) => {
      return api.rpc.chain.getBlock(header.hash.toHex());
    }));
  }
  getBlockByBlockNumber(blockNumber) {
    const $api = this.getApi();
    const $hash = $api.pipe(switchMap((api) => api.rpc.chain.getBlockHash(blockNumber)));
    return combineLatest([$api, $hash]).pipe(switchMap(([api, hashByBlockNumber]) => {
      return api.rpc.chain.getBlock(hashByBlockNumber == null ? void 0 : hashByBlockNumber.toHex());
    }));
  }
  getSigner() {
    const { signer, signingAddress } = this.config;
    if (!signingAddress || (typeof signingAddress === "string" || !("sign" in signingAddress)) && !signer) {
      throw new Error("No signer set");
    }
    return {
      signer,
      signingAddress
    };
  }
  getSignerAddress() {
    const { signingAddress } = this.getSigner();
    if (typeof signingAddress !== "string" && "address" in signingAddress) {
      return signingAddress.address;
    }
    return signingAddress;
  }
  setProxy(proxyAccount) {
    this.config.proxy = proxyAccount;
  }
  clearProxy() {
    this.config.proxy = void 0;
  }
};

// src/modules/metadata.ts
import { first, from as from2, map as map2 } from "rxjs";
function getMetadataModule(inst) {
  function getMetadata(uri) {
    const url = parseMetadataUrl(uri);
    if (!url) {
      return from2([]);
    }
    return inst.getMetadataObservable(url);
  }
  function pinFile(b64URI) {
    var _a;
    if (!((_a = inst.config) == null ? void 0 : _a.pinFile)) {
      console.error("pinFile must be set in config to use this feature");
      return from2([]);
    }
    if (!b64URI) {
      return from2([]);
    }
    return from2(inst.config.pinFile(b64URI)).pipe(first()).pipe(map2(({ uri }) => parseIPFSHash(uri)));
  }
  function pinJson(metadata) {
    const file = jsonToBase64(metadata);
    return pinFile(file);
  }
  function unpinFile(uri) {
    if (!inst.config.unpinFile) {
      return from2([]);
    }
    const hash2 = parseIPFSHash(uri).ipfsHash;
    return inst.config.unpinFile(hash2);
  }
  function parseMetadataUrl(url) {
    try {
      let newUrl;
      if (!url.includes(":")) {
        newUrl = new URL(`ipfs/${url}`, inst.config.metadataHost);
      } else if (url.startsWith("ipfs://")) {
        newUrl = new URL(url.substr(7), inst.config.metadataHost);
      } else {
        newUrl = new URL(url);
      }
      if (newUrl.protocol === "http:" || newUrl.protocol === "https:") {
        return newUrl.href;
      }
      return "";
    } catch (e) {
      return "";
    }
  }
  const IPFS_HASH_LENGTH = 46;
  function parseIPFSHash(uri) {
    if (uri.includes("ipfs://")) {
      const hash2 = uri.split(/ipfs:\/\/ipfs\//).filter(Boolean).join();
      return { uri, ipfsHash: hash2 };
    } else if (!uri.includes("/") && uri.length === IPFS_HASH_LENGTH) {
      return { uri: `ipfs://ipfs/${uri}`, ipfsHash: uri };
    }
    return { uri, ipfsHash: "" };
  }
  return { getMetadata, parseMetadataUrl, pinFile, pinJson, unpinFile };
}
function jsonToBase64(jsonInput) {
  try {
    const json = JSON.stringify(jsonInput);
    return btoa(json);
  } catch (error) {
    throw new Error("Invalid JSON");
  }
}

// src/modules/nfts.ts
import BN4 from "bn.js";
import { combineLatest as combineLatest2, EMPTY, firstValueFrom as firstValueFrom2 } from "rxjs";
import { expand, filter as filter2, map as map3, repeatWhen, switchMap as switchMap2, take as take2 } from "rxjs/operators";

// src/utils/index.ts
var utils_exports = {};
__export(utils_exports, {
  addThousandsSeparators: () => addThousandsSeparators,
  aprToFee: () => aprToFee,
  baseToDisplay: () => baseToDisplay,
  feeToApr: () => feeToApr,
  formatCurrencyAmount: () => formatCurrencyAmount,
  formatPercentage: () => formatPercentage,
  formatRatio: () => formatRatio,
  getRandomUint: () => getRandomUint,
  isLoanPalletAccount: () => isLoanPalletAccount,
  isSameAddress: () => isSameAddress,
  toPerquintill: () => toPerquintill,
  toPrecision: () => toPrecision
});
import { addressEq } from "@polkadot/util-crypto";
import BN3 from "bn.js";
import Decimal2 from "decimal.js-light";
var LoanPalletAccountId = "0x6d6f646c70616c2f6c6f616e0000000000000000000000000000000000000000";
var secondsPerYear2 = Dec(60 * 60 * 24 * 365);
var percentFormatter = new Intl.NumberFormat("en-US", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 4
});
function getRandomUint() {
  return Math.random() * (__pow(2, 53) - 1) >>> 0;
}
function toPerquintill(rate) {
  return new BN3(rate * __pow(10, 6)).mul(new BN3(10).pow(new BN3(18 - 6))).toString();
}
function aprToFee(apr) {
  const i = Dec(apr);
  const fee = i.div(secondsPerYear2).plus(1).mul("1e27").toDecimalPlaces(0);
  return fee.toString();
}
function feeToApr(fee) {
  let feeToConvert = fee;
  if (typeof feeToConvert !== "string" && typeof feeToConvert !== "number") {
    feeToConvert = feeToConvert.toString();
  }
  if (feeToConvert.toString() === "0") {
    return feeToConvert.toString();
  }
  const i = Dec(feeToConvert).div("1e27").minus(1).times(secondsPerYear2);
  return i.mul(100).toDecimalPlaces(2).toString();
}
function baseToDisplay(base, decimals) {
  let baseStr = typeof base === "string" ? base : base.toString();
  const neg = baseStr.includes("-");
  baseStr = baseStr.replace(/-/g, "");
  const a = baseStr.slice(0, -decimals) || "0";
  const b = baseStr.slice(-decimals).padStart(decimals, "0");
  const res = `${a}.${b}`;
  return neg ? `-${res}` : res;
}
function toPrecision(value, precision) {
  const zero = Dec("0").toFixed(precision);
  const result = Dec(value.toString()).toFixed(precision);
  if (zero === result)
    return Dec(value.toString()).toFixed(precision, Decimal2.ROUND_UP);
  return result;
}
function addThousandsSeparators(x) {
  const parts = x.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.join(".");
}
function formatCurrencyAmount(bn, currency, precise) {
  const currencyStr = currency === "native" ? "AIR" : currency || "kusd";
  if (!bn)
    return "";
  return `${addThousandsSeparators(toPrecision(baseToDisplay(new BN3(bn), 18), precise ? 4 : 0))} ${currencyStr}`;
}
function formatPercentage(numerator, denominator) {
  if (!numerator || !denominator)
    return "";
  const a = new BN3(numerator).div(new BN3(1e6));
  let b = new BN3(denominator).div(new BN3(1e6));
  b = b.isZero() ? new BN3(1) : b;
  const percentage = parseInt(a.toString(), 10) / parseInt(b.toString(), 10) * 100;
  return `${percentFormatter.format(percentage)}%`;
}
function formatRatio(ratio) {
  if (!ratio)
    return "";
  return `${addThousandsSeparators(toPrecision(baseToDisplay(ratio || "0", 27), 4))}`;
}
function isSameAddress(a, b) {
  if (!a || !b)
    return false;
  if (a === b)
    return true;
  return addressEq(a, b);
}
function isLoanPalletAccount(address) {
  return isSameAddress(address, LoanPalletAccountId);
}

// src/modules/nfts.ts
var MAX_ATTEMPTS = 10;
var formatCollectionKey = (keys) => keys.toHuman()[0].replace(/\D/g, "");
var formatItemKey = (keys) => keys.toHuman()[1].replace(/\D/g, "");
function getNftsModule(inst) {
  function getCollections() {
    const $api = inst.getApi();
    const $events = inst.getEvents().pipe(filter2(({ api, events }) => {
      const event = events.find(({ event: event2 }) => api.events.uniques.Created.is(event2));
      return !!event;
    }));
    return $api.pipe(switchMap2((api) => combineLatest2([api.query.uniques.classMetadataOf.entries(), api.query.uniques.class.entries()])), map3(([metas, collections]) => {
      const metasObj = metas.reduce((acc, [keys, value]) => {
        acc[formatCollectionKey(keys)] = value.toHuman();
        return acc;
      }, {});
      const mapped = collections.map(([keys, value]) => {
        var _a;
        const id = formatCollectionKey(keys);
        const collectionValue = value.toJSON();
        const collection = {
          id,
          admin: collectionValue.admin,
          owner: collectionValue.owner,
          issuer: collectionValue.issuer,
          items: collectionValue.items,
          metadataUri: (_a = metasObj[id]) == null ? void 0 : _a.data
        };
        return collection;
      });
      return mapped;
    }), repeatWhen(() => $events));
  }
  function getCollection(args) {
    const [collectionId] = args;
    const $api = inst.getApi();
    return $api.pipe(switchMap2((api) => combineLatest2([api.query.uniques.classMetadataOf(collectionId), api.query.uniques.class(collectionId)])), map3(([meta, collectionData]) => {
      var _a;
      const collectionValue = collectionData.toJSON();
      if (!collectionValue)
        throw new Error("Collection not found");
      const collection = {
        id: collectionId,
        admin: collectionValue.admin,
        owner: collectionValue.owner,
        issuer: collectionValue.issuer,
        items: collectionValue.items,
        metadataUri: (_a = meta.toHuman()) == null ? void 0 : _a.data
      };
      return collection;
    }));
  }
  function getCollectionNfts(args) {
    const [collectionId] = args;
    const $api = inst.getApi();
    const $events = inst.getEvents().pipe(filter2(({ api, events }) => {
      const event = events.find(({ event: event2 }) => api.events.uniques.Transferred.is(event2) || api.events.uniques.Issued.is(event2));
      if (!event)
        return false;
      const [cid] = event.toHuman().event.data;
      return cid.replace(/\D/g, "") === collectionId;
    }));
    return $api.pipe(switchMap2((api) => combineLatest2([
      api.query.uniques.instanceMetadataOf.entries(collectionId),
      api.query.uniques.asset.entries(collectionId),
      api.query.nftSales.sales.entries(collectionId)
    ])), map3(([metas, nfts, sales]) => {
      const metasObj = metas.reduce((acc, [keys, value]) => {
        acc[formatItemKey(keys)] = value.toHuman();
        return acc;
      }, {});
      const salesObj = sales.reduce((acc, [keys, value]) => {
        acc[formatItemKey(keys)] = value.toJSON();
        return acc;
      }, {});
      const mapped = nfts.map(([keys, value]) => {
        var _a, _b, _c, _d;
        const id = formatItemKey(keys);
        const nftValue = value.toJSON();
        const nft = {
          id,
          collectionId,
          owner: ((_a = salesObj[id]) == null ? void 0 : _a.seller) || nftValue.owner,
          metadataUri: (_b = metasObj[id]) == null ? void 0 : _b.data,
          sellPrice: ((_c = salesObj[id]) == null ? void 0 : _c.seller) ? parseHex((_d = salesObj[id]) == null ? void 0 : _d.price.amount) : null
        };
        return nft;
      });
      return mapped;
    }), repeatWhen(() => $events));
  }
  function getNft(args) {
    const [collectionId, nftId] = args;
    const $api = inst.getApi();
    return $api.pipe(switchMap2((api) => combineLatest2([
      api.query.uniques.instanceMetadataOf(collectionId, nftId),
      api.query.uniques.asset(collectionId, nftId),
      api.query.nftSales.sales(collectionId, nftId)
    ])), map3(([meta, nftData, sale]) => {
      var _a;
      const nftValue = nftData.toJSON();
      const saleValue = sale.toJSON();
      if (!nftValue)
        throw new Error(`NFT not found: collectionId: ${collectionId}, nftId: ${nftId}`);
      const nft = {
        id: nftId,
        collectionId,
        owner: (saleValue == null ? void 0 : saleValue.seller) || nftValue.owner,
        metadataUri: (_a = meta.toHuman()) == null ? void 0 : _a.data,
        sellPrice: saleValue ? parseHex(saleValue.price.amount) : null
      };
      return nft;
    }));
  }
  function getAccountNfts(args) {
    const [address] = args;
    const $api = inst.getApi();
    const $events = inst.getEvents().pipe(filter2(({ api, events }) => {
      const event = events.find(({ event: event2 }) => api.events.uniques.Transferred.is(event2) || api.events.uniques.Issued.is(event2));
      if (!event)
        return false;
      const [, , from4, to] = event.toJSON().event.data;
      return isSameAddress(address, from4) || to && isSameAddress(address, to);
    }));
    return $api.pipe(switchMap2((api) => combineLatest2([api.query.uniques.account.keys(address), api.query.nftSales.nftsBySeller.keys(address)]), (api, [accountKeys, salesKeys]) => ({
      api,
      accountKeys,
      salesKeys
    })), switchMap2(({ api, accountKeys, salesKeys }) => {
      const accountkeysArr = accountKeys.map((k) => {
        const [, cid, nid] = k.toHuman();
        return [cid.replace(/\D/g, ""), nid.replace(/\D/g, "")];
      });
      const salesKeysArr = salesKeys.map((k) => {
        const [, cid, nid] = k.toHuman();
        return [cid.replace(/\D/g, ""), nid.replace(/\D/g, "")];
      });
      const keysArr = salesKeysArr.concat(accountkeysArr);
      return combineLatest2([
        api.query.uniques.instanceMetadataOf.multi(keysArr),
        api.query.uniques.asset.multi(keysArr),
        api.query.nftSales.sales.multi(salesKeysArr)
      ]).pipe(map3(([metas, nfts, sales]) => {
        const mapped = nfts.map((value, i) => {
          var _a, _b, _c;
          const [collectionId, id] = keysArr[i];
          const instance = value.toJSON();
          const sale = (_a = sales[i]) == null ? void 0 : _a.toJSON();
          const nft = {
            id,
            collectionId,
            owner: (sale == null ? void 0 : sale.seller) || instance.owner,
            metadataUri: (_c = (_b = metas[i]) == null ? void 0 : _b.toHuman()) == null ? void 0 : _c.data,
            sellPrice: sale ? parseHex(sale.price.amount) : null
          };
          return nft;
        });
        return mapped;
      }), take2(1));
    }), repeatWhen(() => $events));
  }
  function createCollection(args, options) {
    const [collectionId, owner, metadata] = args;
    const $api = inst.getApi();
    const $pinnedMetadata = inst.metadata.pinJson({
      image: metadata.image,
      name: metadata.name,
      description: metadata.description
    });
    return combineLatest2([$api, $pinnedMetadata]).pipe(map3(([api, pinnedMetadata]) => {
      return {
        api,
        submittable: api.tx.utility.batchAll([
          api.tx.uniques.create(collectionId, owner),
          api.tx.uniques.setCollectionMetadata(collectionId, pinnedMetadata.uri, true)
        ])
      };
    }), switchMap2(({ api, submittable }) => inst.wrapSignAndSend(api, submittable, options)));
  }
  function transferNft(args, options) {
    const $api = inst.getApi();
    return $api.pipe(map3((api) => ({
      api,
      submittable: api.tx.uniques.transfer(...args)
    })), switchMap2(({ api, submittable }) => inst.wrapSignAndSend(api, submittable, options)));
  }
  function mintNft(args, options) {
    const $api = inst.getApi();
    const [collectionId, nftId, owner, metadata] = args;
    const $pinnedMetadata = inst.metadata.pinJson({
      image: metadata.image,
      name: metadata.name,
      description: metadata.description
    });
    return combineLatest2([$api, $pinnedMetadata]).pipe(map3(([api, pinnedMetadata]) => {
      return {
        api,
        submittable: api.tx.utility.batchAll([
          api.tx.uniques.mint(collectionId, nftId, owner),
          api.tx.uniques.setMetadata(collectionId, nftId, pinnedMetadata.uri, true)
        ])
      };
    }), switchMap2(({ api, submittable }) => inst.wrapSignAndSend(api, submittable, options)));
  }
  function sellNft(args, options) {
    const [collectionId, nftId, price] = args;
    const $api = inst.getApi();
    return $api.pipe(map3((api) => ({
      api,
      submittable: api.tx.nftSales.add(collectionId, nftId, ["Native", price.toString()])
    })), switchMap2(({ api, submittable }) => inst.wrapSignAndSend(api, submittable, options)));
  }
  function removeNftListing(args, options) {
    const [collectionId, nftId] = args;
    const $api = inst.getApi();
    return $api.pipe(map3((api) => ({
      api,
      submittable: api.tx.nftSales.remove(collectionId, nftId)
    })), switchMap2(({ api, submittable }) => inst.wrapSignAndSend(api, submittable, options)));
  }
  function buyNft(args, options) {
    const [collectionId, nftId, price] = args;
    const $api = inst.getApi();
    return $api.pipe(map3((api) => ({
      api,
      submittable: api.tx.nftSales.buy(collectionId, nftId, ["Native", price.toString()])
    })), switchMap2(({ api, submittable }) => inst.wrapSignAndSend(api, submittable, options)));
  }
  function getAvailableCollectionId() {
    return __async(this, null, function* () {
      const $api = inst.getApi();
      try {
        const res = yield firstValueFrom2($api.pipe(map3((api) => ({
          api,
          id: null,
          triesLeft: MAX_ATTEMPTS
        })), expand(({ api, triesLeft }) => {
          const id = String(getRandomUint());
          if (triesLeft <= 0)
            return EMPTY;
          return api.query.uniques.class(id).pipe(map3((res2) => ({ api, id: res2.toJSON() === null ? id : null, triesLeft: triesLeft - 1 })), take2(1));
        }), filter2(({ id }) => !!id)));
        return res.id;
      } catch (e) {
        throw new Error(`Could not find an available collection ID in ${MAX_ATTEMPTS} attempts`);
      }
    });
  }
  function getAvailableNftId(collectionId) {
    return __async(this, null, function* () {
      const $api = inst.getApi();
      try {
        const res = yield firstValueFrom2($api.pipe(map3((api) => ({
          api,
          id: null,
          triesLeft: MAX_ATTEMPTS
        })), expand(({ api, triesLeft }) => {
          const id = String(getRandomUint());
          if (triesLeft <= 0)
            return EMPTY;
          return api.query.uniques.asset(collectionId, id).pipe(map3((res2) => ({ api, id: res2.toJSON() === null ? id : null, triesLeft: triesLeft - 1 })), take2(1));
        }), filter2(({ id }) => !!id)));
        return res.id;
      } catch (e) {
        throw new Error(`Could not find an available NFT ID in ${MAX_ATTEMPTS} attempts`);
      }
    });
  }
  return {
    getCollections,
    getCollection,
    getCollectionNfts,
    getAccountNfts,
    getNft,
    getAvailableCollectionId,
    getAvailableNftId,
    createCollection,
    mintNft,
    transferNft,
    sellNft,
    removeNftListing,
    buyNft
  };
}
var parseHex = (value) => {
  return new BN4(value.toString().substring(2), "hex").toString();
};

// src/modules/pools.ts
var import_blake2b = __toESM(require_blake2b());
import BN5 from "bn.js";
import { combineLatest as combineLatest3, EMPTY as EMPTY2, expand as expand2, firstValueFrom as firstValueFrom3, from as from3, of as of2 } from "rxjs";
import { combineLatestWith as combineLatestWith2, filter as filter3, map as map4, repeatWhen as repeatWhen2, switchMap as switchMap3, take as take3 } from "rxjs/operators";
var PerquintillBN = new BN5(10).pow(new BN5(18));
var PriceBN = new BN5(10).pow(new BN5(27));
var LoanPalletAccountId2 = "0x6d6f646c70616c2f6c6f616e0000000000000000000000000000000000000000";
var AdminRoleBits = {
  PoolAdmin: 1,
  Borrower: 2,
  PricingAdmin: 4,
  LiquidityAdmin: 8,
  MemberListAdmin: 16,
  LoanAdmin: 32
};
var LOAN_INPUT_TRANSFORM = {
  value: (v) => v.toString(),
  maturityDate: (v) => new Date(v).getTime() / 1e3,
  probabilityOfDefault: (v) => v.toString(),
  lossGivenDefault: (v) => v.toString(),
  discountRate: (v) => v.toString(),
  advanceRate: (v) => v.toString()
};
var LOAN_FIELDS = {
  BulletLoan: ["advanceRate", "probabilityOfDefault", "lossGivenDefault", "value", "discountRate", "maturityDate"],
  CreditLine: ["advanceRate", "value"],
  CreditLineWithMaturity: [
    "advanceRate",
    "probabilityOfDefault",
    "lossGivenDefault",
    "value",
    "discountRate",
    "maturityDate"
  ]
};
var LoanStatus = /* @__PURE__ */ ((LoanStatus2) => {
  LoanStatus2["Created"] = "Created";
  LoanStatus2["Active"] = "Active";
  LoanStatus2["Closed"] = "Closed";
  return LoanStatus2;
})(LoanStatus || {});
var formatPoolKey = (keys) => keys.toHuman()[0].replace(/\D/g, "");
var formatLoanKey = (keys) => keys.toHuman()[1].replace(/\D/g, "");
var MAX_ATTEMPTS2 = 10;
function getPoolsModule(inst) {
  function createPool(args, options) {
    const [admin, poolId, collectionId, tranches, currency, maxReserve, metadata] = args;
    const trancheInput = tranches.map((t) => {
      var _a;
      return [
        t.interestRatePerSec ? { NonResidual: [t.interestRatePerSec.toString(), (_a = t.minRiskBuffer) == null ? void 0 : _a.toString()] } : "Residual"
      ];
    });
    const $pinMetadata = pinPoolMetadata(metadata, poolId, currency, options);
    const $api = inst.getApi();
    return combineLatest3([$api, $pinMetadata]).pipe(switchMap3(([api, pinnedMetadata]) => {
      var _a;
      let submittable;
      if (["propose", "notePreimage"].includes((_a = options == null ? void 0 : options.createType) != null ? _a : "")) {
        submittable = api.tx.pools.create(admin, poolId, trancheInput, currency, maxReserve.toString(), pinnedMetadata.ipfsHash);
      } else {
        submittable = api.tx.utility.batchAll([
          api.tx.uniques.create(collectionId, LoanPalletAccountId2),
          api.tx.pools.create(inst.getSignerAddress(), poolId, trancheInput, currency, maxReserve.toString(), pinnedMetadata.ipfsHash),
          api.tx.permissions.add({ PoolRole: "PoolAdmin" }, admin, { Pool: poolId }, {
            PoolRole: "LoanAdmin"
          }),
          api.tx.loans.initialisePool(poolId, collectionId)
        ]);
      }
      if ((options == null ? void 0 : options.createType) === "propose") {
        const proposalSubmittable = api.tx.utility.batchAll([
          api.tx.democracy.notePreimage(submittable.method.toHex()),
          api.tx.democracy.propose(submittable.method.hash, api.consts.democracy.minimumDeposit)
        ]);
        return inst.wrapSignAndSend(api, proposalSubmittable, options);
      }
      if ((options == null ? void 0 : options.createType) === "notePreimage") {
        const preimageSubmittable = api.tx.democracy.notePreimage(submittable.method.toHex());
        return inst.wrapSignAndSend(api, preimageSubmittable, options);
      }
      return inst.wrapSignAndSend(api, submittable, options);
    }));
  }
  function pinPoolMetadata(metadata, poolId, currency, options) {
    var _a;
    if (options == null ? void 0 : options.paymentInfo) {
      return of2({ uri: "", ipfsHash: "" });
    }
    const tranchesById = {};
    metadata.tranches.forEach((tranche, index) => {
      tranchesById[computeTrancheId(index, poolId)] = {
        name: tranche.tokenName,
        symbol: tranche.symbolName,
        minInitialInvestment: CurrencyBalance.fromFloat(tranche.minInvestment, getCurrencyDecimals(currency)).toString()
      };
    });
    const formattedMetadata = {
      version: 1,
      pool: {
        name: metadata.poolName,
        icon: metadata.poolIcon,
        asset: { class: metadata.assetClass },
        issuer: {
          name: metadata.issuerName,
          description: metadata.issuerDescription,
          email: metadata.email,
          logo: metadata.issuerLogo
        },
        links: {
          executiveSummary: metadata.executiveSummary,
          forum: metadata.forum,
          website: metadata.website
        },
        status: "open",
        listed: true
      },
      node: {
        url: (_a = metadata.nodeEndpoint) != null ? _a : null
      },
      tranches: tranchesById,
      riskGroups: metadata.riskGroups.map((group) => ({
        name: group.groupName,
        advanceRate: Rate.fromPercent(group.advanceRate).toString(),
        interestRatePerSec: Rate.fromAprPercent(group.fee).toString(),
        probabilityOfDefault: Rate.fromPercent(group.probabilityOfDefault).toString(),
        lossGivenDefault: Rate.fromPercent(group.lossGivenDefault).toString(),
        discountRate: Rate.fromAprPercent(group.discountRate).toString()
      }))
    };
    return inst.metadata.pinJson(formattedMetadata);
  }
  function updatePool(args, options) {
    const [poolId, updates] = args;
    const { minEpochTime, tranches, maxNavAge } = updates;
    const $api = inst.getApi();
    return $api.pipe(switchMap3((api) => {
      const submittable = api.tx.pools.update(poolId, { minEpochTime, tranches, maxNavAge });
      return inst.wrapSignAndSend(api, submittable, options);
    }));
  }
  function updatePoolRoles(args, options) {
    const [poolId, add, remove] = args;
    const signer = inst.getSignerAddress();
    const sortedRemove = [...remove].sort(([addr, role]) => role === "PoolAdmin" && isSameAddress(addr, signer) ? 1 : -1);
    const $api = inst.getApi();
    return $api.pipe(switchMap3((api) => {
      const submittable = api.tx.utility.batchAll([
        ...add.map(([addr, role]) => api.tx.permissions.add({ PoolRole: typeof role === "string" ? "PoolAdmin" : "MemberListAdmin" }, addr, { Pool: poolId }, { PoolRole: role })),
        ...sortedRemove.map(([addr, role]) => api.tx.permissions.remove({ PoolRole: typeof role === "string" ? "PoolAdmin" : "MemberListAdmin" }, addr, { Pool: poolId }, { PoolRole: role }))
      ]);
      return inst.wrapSignAndSend(api, submittable, options);
    }));
  }
  function setMaxReserve(args, options) {
    const [poolId, maxReserve] = args;
    const $api = inst.getApi();
    return $api.pipe(switchMap3((api) => {
      const submittable = api.tx.pools.setMaxReserve(poolId, maxReserve.toString());
      return inst.wrapSignAndSend(api, submittable, options);
    }));
  }
  function setMetadata(args, options) {
    const [poolId, metadata] = args;
    const $api = inst.getApi();
    if (metadata == null ? void 0 : metadata.version) {
      metadata.version = metadata.version + 1;
    } else {
      metadata.version = 1;
    }
    const $pinnedMetadata = inst.metadata.pinJson(metadata);
    return combineLatest3([$api, $pinnedMetadata]).pipe(switchMap3(([api, pinnedMetadata]) => {
      const submittable = api.tx.pools.setMetadata(poolId, pinnedMetadata.ipfsHash);
      return inst.wrapSignAndSend(api, submittable, options);
    }));
  }
  function updateInvestOrder(args, options) {
    const [poolId, trancheId, newOrder] = args;
    const address = inst.getSignerAddress();
    const $api = inst.getApi();
    return $api.pipe(combineLatestWith2(getPool([poolId])), combineLatestWith2(getOrder([address, poolId, trancheId])), take3(1), switchMap3(([[api, pool], order]) => {
      let submittable;
      if (order.epoch <= pool.epoch.lastExecuted && order.epoch > 0 && (!order.invest.isZero() || !order.redeem.isZero())) {
        submittable = api.tx.utility.batchAll([
          api.tx.pools.collect(poolId, { id: trancheId }, pool.epoch.lastExecuted + 1 - order.epoch),
          api.tx.pools.updateInvestOrder(poolId, { id: trancheId }, newOrder.toString())
        ]);
      } else {
        submittable = api.tx.pools.updateInvestOrder(poolId, { id: trancheId }, newOrder.toString());
      }
      return inst.wrapSignAndSend(api, submittable, options);
    }));
  }
  function updateRedeemOrder(args, options) {
    const [poolId, trancheId, newOrder] = args;
    const address = inst.getSignerAddress();
    const $api = inst.getApi();
    return $api.pipe(combineLatestWith2(getPool([poolId])), combineLatestWith2(getOrder([address, poolId, trancheId])), take3(1), switchMap3(([[api, pool], order]) => {
      let submittable;
      if (order.epoch <= pool.epoch.lastExecuted && order.epoch > 0 && (!order.invest.isZero() || !order.redeem.isZero())) {
        submittable = api.tx.utility.batchAll([
          api.tx.pools.collect(poolId, { id: trancheId }, pool.epoch.lastExecuted + 1 - order.epoch),
          api.tx.pools.updateRedeemOrder(poolId, { id: trancheId }, newOrder.toString())
        ]);
      } else {
        submittable = api.tx.pools.updateRedeemOrder(poolId, { id: trancheId }, newOrder.toString());
      }
      return inst.wrapSignAndSend(api, submittable, options);
    }));
  }
  function closeEpoch(args, options) {
    const [poolId, batchSolution] = args;
    const $api = inst.getApi();
    const $solution = batchSolution ? submitSolution([poolId], { dryRun: true }) : of2(null);
    return combineLatest3([$api, $solution]).pipe(switchMap3(([api, optimalSolution]) => {
      if (optimalSolution) {
        const trancheSolution = optimalSolution.tranches.map((tranche) => [
          tranche.invest.perquintill,
          tranche.redeem.perquintill
        ]);
        const submittable2 = api.tx.utility.batchAll([
          api.tx.loans.updateNav(poolId),
          api.tx.pools.closeEpoch(poolId),
          api.tx.pools.submitSolution(poolId, trancheSolution)
        ]);
        return inst.wrapSignAndSend(api, submittable2, options);
      }
      const submittable = api.tx.utility.batchAll([api.tx.loans.updateNav(poolId), api.tx.pools.closeEpoch(poolId)]);
      return inst.wrapSignAndSend(api, submittable, options);
    }));
  }
  function executeEpoch(args, options) {
    const [poolId] = args;
    const $api = inst.getApi();
    return $api.pipe(switchMap3((api) => {
      const submittable = api.tx.pools.executeEpoch(poolId);
      return inst.wrapSignAndSend(api, submittable, options);
    }));
  }
  function submitSolution(args, options) {
    const [poolId] = args;
    const $pool = getPool([poolId]).pipe(take3(1));
    const $api = inst.getApi();
    return combineLatest3([$pool]).pipe(switchMap3(([pool]) => {
      const solutionTranches = pool.tranches.map((tranche) => ({
        ratio: tranche.ratio,
        minRiskBuffer: tranche.minRiskBuffer
      }));
      const poolState = {
        netAssetValue: pool.nav.latest,
        reserve: pool.reserve.total,
        tranches: solutionTranches,
        maxReserve: pool.reserve.max,
        currencyDecimals: pool.currencyDecimals
      };
      const orders = pool.tranches.map((tranche) => ({
        invest: tranche.outstandingInvestOrders,
        redeem: tranche.outstandingRedeemOrders
      }));
      const redeemStartWeight = new BN5(10).pow(new BN5(solutionTranches.length));
      const weights = solutionTranches.map((_t, index) => ({
        invest: new BN5(10).pow(new BN5(solutionTranches.length - index)),
        redeem: redeemStartWeight.mul(new BN5(10).pow(new BN5(index).addn(1)))
      }));
      const $solution = from3(calculateOptimalSolution(poolState, orders, weights));
      return combineLatest3([$api, $solution]);
    }), switchMap3(([api, optimalSolution]) => {
      if (!optimalSolution.isFeasible) {
        console.warn("Calculated solution is not feasible");
        return of2(null);
      }
      if (options == null ? void 0 : options.dryRun) {
        return of2(optimalSolution);
      }
      const solution = optimalSolution.tranches.map((tranche) => [
        tranche.invest.perquintill,
        tranche.redeem.perquintill
      ]);
      const submittable = api.tx.pools.submitSolution(poolId, solution);
      return inst.wrapSignAndSend(api, submittable, options);
    }));
  }
  function collect(args, options) {
    const [poolId, trancheId] = args;
    const $api = inst.getApi();
    const address = inst.getSignerAddress();
    if (trancheId !== void 0) {
      return $api.pipe(combineLatestWith2(getPool([poolId])), combineLatestWith2(getOrder([address, poolId, trancheId])), switchMap3(([[api, pool], order]) => {
        const submittable = api.tx.pools.collect(poolId, { id: trancheId }, pool.epoch.lastExecuted + 1 - order.epoch);
        return inst.wrapSignAndSend(api, submittable, options);
      }));
    }
    return $api.pipe(combineLatestWith2(getPool([poolId]).pipe(switchMap3((pool) => combineLatest3(pool.tranches.map((t) => getOrder([address, poolId, t.id]))), (pool, orders) => ({
      pool,
      orders
    })))), take3(1), switchMap3(([api, { pool, orders }]) => {
      const submittable = api.tx.utility.batchAll(pool.tranches.map((_t, index) => {
        const nEpochs = pool.epoch.lastExecuted + 1 - orders[index].epoch;
        if (!nEpochs)
          return null;
        return api.tx.pools.collect(poolId, { index }, nEpochs);
      }).filter(Boolean));
      return inst.wrapSignAndSend(api, submittable, options);
    }));
  }
  function getUserPermissions(args) {
    const [address] = args;
    const $api = inst.getApi();
    const $events = inst.getEvents().pipe(filter3(({ api, events }) => {
      const event = events.find(({ event: event2 }) => api.events.permissions.Added.is(event2) || api.events.permissions.Removed.is(event2));
      if (!event)
        return false;
      const [accountId] = event.toJSON().event.data;
      return isSameAddress(address, accountId);
    }));
    return $api.pipe(switchMap3((api) => api.query.permissions.permission.entries(address)), map4((permissionsData) => {
      const roles = {
        pools: {},
        currencies: {}
      };
      permissionsData.forEach(([keys, value]) => {
        const key = keys.toHuman()[1];
        if ("Pool" in key) {
          const poolId = key.Pool.replace(/\D/g, "");
          const permissions = value.toJSON();
          roles.pools[poolId] = {
            roles: ["PoolAdmin", "Borrower", "PricingAdmin", "LiquidityAdmin", "MemberListAdmin", "LoanAdmin"].filter((role) => AdminRoleBits[role] & permissions.poolAdmin.bits),
            tranches: {}
          };
          permissions.trancheInvestor.info.filter((info) => info.permissionedTill * 1e3 > Date.now()).forEach((info) => {
            roles.pools[poolId].tranches[info.trancheId] = new Date(info.permissionedTill * 1e3).toISOString();
          });
        }
      });
      return roles;
    }), repeatWhen2(() => $events));
  }
  function getPoolPermissions(args) {
    const [poolId] = args;
    const $api = inst.getApi();
    const $events = inst.getEvents().pipe(filter3(({ api, events }) => {
      var _a;
      const event = events.find(({ event: event2 }) => api.events.permissions.Added.is(event2) || api.events.permissions.Removed.is(event2));
      if (!event)
        return false;
      const [, scope] = event.toHuman().event.data;
      return poolId === ((_a = scope.Pool) == null ? void 0 : _a.replace(/\D/g, ""));
    }));
    return $api.pipe(switchMap3((api) => api.query.permissions.permission.keys(), (api, keys) => ({ api, keys })), switchMap3(({ keys, api }) => {
      const poolKeys = keys.map((key) => {
        const [account, scope] = key.toHuman();
        return [account, scope.Pool ? { Pool: scope.Pool.replace(/\D/g, "") } : null];
      }).filter(([, scope]) => {
        return (scope == null ? void 0 : scope.Pool) === poolId;
      });
      return api.query.permissions.permission.multi(poolKeys).pipe(map4((permissionsData) => {
        const roles = {};
        permissionsData.forEach((value, i) => {
          const account = poolKeys[i][0];
          const permissions = value.toJSON();
          roles[account] = {
            roles: ["PoolAdmin", "Borrower", "PricingAdmin", "LiquidityAdmin", "MemberListAdmin", "LoanAdmin"].filter((role) => AdminRoleBits[role] & permissions.poolAdmin.bits),
            tranches: {}
          };
          permissions.trancheInvestor.info.filter((info) => info.permissionedTill * 1e3 > Date.now()).forEach((info) => {
            roles[account].tranches[info.trancheId] = new Date(info.permissionedTill * 1e3).toISOString();
          });
        });
        return roles;
      }));
    }), take3(1), repeatWhen2(() => $events));
  }
  function getNextLoanId(args) {
    return __async(this, null, function* () {
      const [poolId] = args;
      const $api = inst.getApi();
      const id = yield firstValueFrom3($api.pipe(switchMap3((api) => api.query.loans.nextLoanId(poolId))));
      return id;
    });
  }
  function createLoan(args, options) {
    const [poolId, collectionId, nftId] = args;
    const $api = inst.getApi();
    return $api.pipe(switchMap3((api) => {
      const submittable = api.tx.loans.create(poolId, [collectionId, nftId]);
      return inst.wrapSignAndSend(api, submittable, options);
    }));
  }
  function priceLoan(args, options) {
    const [poolId, loanId, ratePerSec, loanInfoInput] = args;
    const loanInfoFields = LOAN_FIELDS[loanInfoInput.type];
    const loanInfo = loanInfoFields.map((key) => LOAN_INPUT_TRANSFORM[key](loanInfoInput[key]));
    const $api = inst.getApi();
    return $api.pipe(switchMap3((api) => {
      const submittable = api.tx.loans.price(poolId, loanId, ratePerSec, {
        [loanInfoInput.type]: loanInfo
      });
      return inst.wrapSignAndSend(api, submittable, options);
    }));
  }
  function financeLoan(args, options) {
    const [poolId, loanId, amount] = args;
    const $api = inst.getApi();
    return $api.pipe(switchMap3((api) => {
      const submittable = api.tx.loans.borrow(poolId, loanId, amount.toString());
      return inst.wrapSignAndSend(api, submittable, options);
    }));
  }
  function repayLoanPartially(args, options) {
    const [poolId, loanId, amount] = args;
    const $api = inst.getApi();
    return $api.pipe(switchMap3((api) => {
      const submittable = api.tx.loans.repay(poolId, loanId, amount.toString());
      return inst.wrapSignAndSend(api, submittable, options);
    }));
  }
  function repayAndCloseLoan(args, options) {
    const [poolId, loanId] = args;
    const $api = inst.getApi();
    return $api.pipe(combineLatestWith2(getLoan([poolId, loanId])), combineLatestWith2(getPool([poolId])), take3(1), switchMap3(([[api, loan], pool]) => {
      const secondsPerHour = 60 * 60;
      const debtWithMargin = (loan == null ? void 0 : loan.status) === "Active" ? loan.outstandingDebt.toDecimal().add(loan.normalizedDebt.toDecimal().mul(loan.interestRatePerSec.toDecimal().minus(1).mul(secondsPerHour))) : Dec(0);
      const amount = CurrencyBalance.fromFloat(debtWithMargin || 0, pool.currencyDecimals).toString();
      const submittable = api.tx.utility.batchAll([
        api.tx.loans.repay(poolId, loanId, amount),
        api.tx.loans.close(poolId, loanId)
      ]);
      return inst.wrapSignAndSend(api, submittable, options);
    }));
  }
  function closeLoan(args, options) {
    const [poolId, loanId] = args;
    const $api = inst.getApi();
    return $api.pipe(switchMap3((api) => {
      const submittable = api.tx.loans.close(poolId, loanId);
      return inst.wrapSignAndSend(api, submittable, options);
    }));
  }
  function getPools() {
    const $api = inst.getApi();
    const $events = inst.getEvents().pipe(filter3(({ api, events }) => {
      const event = events.find(({ event: event2 }) => api.events.pools.Created.is(event2) || api.events.pools.Updated.is(event2) || api.events.pools.MaxReserveSet.is(event2) || api.events.pools.MetadataSet.is(event2) || api.events.pools.EpochClosed.is(event2) || api.events.pools.EpochExecuted.is(event2) || api.events.pools.InvestOrderUpdated.is(event2) || api.events.pools.RedeemOrderUpdated.is(event2) || api.events.pools.SolutionSubmitted.is(event2));
      return !!event;
    }));
    const $query = inst.getSubqueryObservable(`query {
          pools {
            nodes {
              id
              createdAt
            }
          }
        }`, {}, true);
    return $api.pipe(switchMap3((api) => combineLatest3([
      api.query.pools.pool.entries(),
      api.query.loans.poolNAV.entries(),
      api.query.pools.epochExecution.entries()
    ]), (api, [rawPools, rawNavs, rawEpochExecutions]) => ({ api, rawPools, rawNavs, rawEpochExecutions })), switchMap3(({ api, rawPools, rawNavs, rawEpochExecutions }) => {
      if (!rawPools.length)
        return of2([]);
      const navMap = rawNavs.reduce((acc, [key, navValue]) => {
        const poolId = formatPoolKey(key);
        const nav = navValue.toJSON();
        acc[poolId] = {
          latest: nav ? nav.latest : "0",
          lastUpdated: nav ? nav.lastUpdated : 0
        };
        return acc;
      }, {});
      const epochExecutionMap = rawEpochExecutions.reduce((acc, [key, navValue]) => {
        const poolId = formatPoolKey(key);
        const epoch = navValue.toJSON();
        acc[poolId] = {
          epoch: epoch.epoch,
          challengePeriodEnd: epoch.challengePeriodEnd
        };
        return acc;
      }, {});
      const pools = rawPools.map(([poolKeys, poolValue]) => {
        var _a;
        return {
          id: formatPoolKey(poolKeys),
          data: poolValue.toJSON(),
          metadata: (_a = poolValue == null ? void 0 : poolValue.toHuman()) == null ? void 0 : _a.metadata
        };
      });
      const keys = pools.map(({ id, data }) => {
        return data.tranches.ids.map((tid) => [id, tid, data.epoch.lastExecuted]);
      }).flat();
      const trancheIdToIndex = {};
      keys.forEach(([, tid], i) => {
        trancheIdToIndex[tid] = i;
      });
      const issuanceKeys = keys.map(([poolId, trancheId]) => ({ Tranche: [poolId, trancheId] }));
      const $issuance = api.query.ormlTokens.totalIssuance.multi(issuanceKeys).pipe(take3(1));
      const epochKeys = keys.map((k) => k.slice(1));
      const $epochs = api.query.pools.epoch.multi(epochKeys).pipe(take3(1));
      const $block = inst.getBlocks().pipe(take3(1));
      return combineLatest3([$issuance, $epochs, $block]).pipe(map4(([rawIssuances, rawEpochs, { block }]) => {
        const blockNumber = block.header.number.toNumber();
        const epochs = rawEpochs.map((value) => !value.isEmpty ? value.toJSON() : null);
        const mappedPools = pools.map((poolObj) => {
          var _a;
          const { data: pool, id: poolId, metadata } = poolObj;
          const navData = navMap[poolId];
          const epochExecution = epochExecutionMap[poolId];
          const currency = getCurrency(pool.currency);
          const currencyDecimals = getCurrencyDecimals(pool.currency);
          const poolValue = new CurrencyBalance(pool.tranches.tranches.reduce((prev, tranche) => {
            return new BN5(prev.add(new BN5(hexToBN(tranche.debt))).add(new BN5(hexToBN(tranche.reserve))));
          }, new BN5(0)), currencyDecimals);
          const maxReserve = new CurrencyBalance(hexToBN(pool.reserve.max), currencyDecimals);
          const availableReserve = new CurrencyBalance(hexToBN(pool.reserve.available), currencyDecimals);
          const totalReserve = new CurrencyBalance(hexToBN(pool.reserve.total), currencyDecimals);
          const mappedPool = {
            id: poolId,
            createdAt: null,
            metadata,
            currency,
            currencyDecimals,
            tranches: pool.tranches.tranches.map((tranche, index) => {
              var _a2;
              const trancheId = pool.tranches.ids[index];
              const trancheIndex = trancheIdToIndex[trancheId];
              const lastClosedEpoch = epochs[trancheIndex];
              let minRiskBuffer = null;
              let interestRatePerSec = null;
              if ("nonResidual" in tranche.trancheType) {
                minRiskBuffer = new Perquintill(hexToBN(tranche.trancheType.nonResidual.minRiskBuffer));
                interestRatePerSec = new Rate(hexToBN(tranche.trancheType.nonResidual.interestRatePerSec));
              }
              const subordinateTranchesValue = new CurrencyBalance(pool.tranches.tranches.slice(0, index).reduce((prev, tranche2) => {
                return new BN5(prev.add(new BN5(hexToBN(tranche2.debt))).add(new BN5(hexToBN(tranche2.reserve))));
              }, new BN5(0)), currencyDecimals);
              const tokenPrice = lastClosedEpoch ? new Price(hexToBN(lastClosedEpoch.tokenPrice)) : Price.fromFloat(1);
              const currentRiskBuffer = subordinateTranchesValue.gtn(0) ? Perquintill.fromFloat(subordinateTranchesValue.toDecimal().div(poolValue.toDecimal())) : new Perquintill(0);
              const outstandingInvestOrders = new CurrencyBalance(hexToBN(tranche.outstandingInvestOrders), currencyDecimals);
              const outstandingRedeemOrders = new TokenBalance(hexToBN(tranche.outstandingRedeemOrders), currencyDecimals);
              const protection = (_a2 = minRiskBuffer == null ? void 0 : minRiskBuffer.toDecimal()) != null ? _a2 : Dec(0);
              const tvl = poolValue.toDecimal();
              let capacityGivenMaxReserve = maxReserve.toDecimal().minus(totalReserve.toDecimal()).minus(outstandingInvestOrders.toDecimal()).add(outstandingRedeemOrders.toDecimal());
              capacityGivenMaxReserve = capacityGivenMaxReserve.lt(0) ? Dec(0) : capacityGivenMaxReserve;
              const capacityGivenProtection = protection.isZero() ? capacityGivenMaxReserve : currentRiskBuffer.toDecimal().div(protection).mul(tvl).minus(tvl);
              const capacity = capacityGivenMaxReserve.gt(capacityGivenProtection) ? capacityGivenProtection : capacityGivenMaxReserve;
              return {
                id: trancheId,
                index,
                seniority: tranche.seniority,
                tokenPrice,
                currency,
                currencyDecimals: 12,
                totalIssuance: new TokenBalance(rawIssuances[trancheIndex].toString(), currencyDecimals),
                poolId,
                poolMetadata: metadata != null ? metadata : void 0,
                interestRatePerSec,
                minRiskBuffer,
                currentRiskBuffer,
                capacity: CurrencyBalance.fromFloat(capacity, currencyDecimals),
                ratio: new Perquintill(hexToBN(tranche.ratio)),
                outstandingInvestOrders,
                outstandingRedeemOrders,
                lastUpdatedInterest: new Date(tranche.lastUpdatedInterest * 1e3).toISOString(),
                balance: new TokenBalance(hexToBN(tranche.debt).add(hexToBN(tranche.reserve)), currencyDecimals)
              };
            }),
            reserve: {
              max: maxReserve,
              available: availableReserve,
              total: totalReserve
            },
            epoch: __spreadProps(__spreadValues({}, pool.epoch), {
              lastClosed: new Date(pool.epoch.lastClosed * 1e3).toISOString(),
              status: getEpochStatus(epochExecution, blockNumber),
              challengePeriodEnd: epochExecution == null ? void 0 : epochExecution.challengePeriodEnd,
              challengeTime: api.consts.pools.challengeTime.toJSON()
            }),
            parameters: __spreadValues({}, pool.parameters),
            nav: {
              latest: (navData == null ? void 0 : navData.latest) ? new CurrencyBalance(hexToBN(navData.latest), currencyDecimals) : new CurrencyBalance(0, currencyDecimals),
              lastUpdated: new Date(((_a = navData == null ? void 0 : navData.lastUpdated) != null ? _a : 0) * 1e3).toISOString()
            },
            value: new CurrencyBalance(hexToBN(pool.reserve.total).add(new BN5((navData == null ? void 0 : navData.latest) ? hexToBN(navData.latest) : 0)), currencyDecimals)
          };
          return mappedPool;
        });
        return mappedPools;
      }));
    }), combineLatestWith2($query), map4(([pools, gqlResult]) => {
      return pools.map((pool) => {
        var _a;
        const gqlPool = gqlResult == null ? void 0 : gqlResult.pools.nodes.find((r) => r.id === pool.id);
        const poolWithGqlData = __spreadProps(__spreadValues({}, pool), {
          createdAt: (_a = gqlPool == null ? void 0 : gqlPool.createdAt) != null ? _a : null
        });
        return poolWithGqlData;
      });
    }), repeatWhen2(() => $events));
  }
  function getPool(args) {
    const [poolId] = args;
    return getPools().pipe(map4((pools) => {
      const pool = pools.find(({ id }) => id === poolId);
      if (!pool)
        throw new Error(`Pool not found with poolId: ${poolId}`);
      return pool;
    }));
  }
  function getDailyPoolStates(args) {
    const [poolId] = args;
    const $api = inst.getApi();
    const $query = inst.getSubqueryObservable(`query($poolId: String!) {
        poolSnapshots(
          orderBy: BLOCK_NUMBER_ASC,
          filter: { 
            id: { startsWith: $poolId },
          }) {
          nodes {
            id
            timestamp
            totalReserve
            netAssetValue
          }
        }
      }
      `, {
      poolId
    });
    return $api.pipe(switchMap3((api) => combineLatest3([$query, api.query.pools.pool(poolId).pipe(take3(1))]).pipe(switchMap3(([queryData, poolValue]) => {
      const pool = poolValue.toJSON();
      const currencyDecimals = getCurrencyDecimals(pool.currency);
      return [
        queryData == null ? void 0 : queryData.poolSnapshots.nodes.map((state) => {
          const poolState = {
            id: state.id,
            netAssetValue: new CurrencyBalance(state.netAssetValue, currencyDecimals),
            totalReserve: new CurrencyBalance(state.totalReserve, currencyDecimals)
          };
          const poolValue2 = new CurrencyBalance(new BN5((state == null ? void 0 : state.netAssetValue) || "0").add(new BN5((state == null ? void 0 : state.totalReserve) || "0")), currencyDecimals);
          return __spreadProps(__spreadValues({}, state), { poolState, poolValue: poolValue2 });
        })
      ];
    }))));
  }
  function getDailyTrancheStates(args) {
    const [trancheId] = args;
    const $query = inst.getSubqueryObservable(`query($trancheId: String!) {
        trancheSnapshots(
          orderBy: BLOCK_NUMBER_ASC,
          filter: { 
            trancheId: { includes: $trancheId },
          }) {
          nodes {
            price
            blockNumber
            timestamp
            trancheId
            tranche {
              poolId
              trancheId
            }
          }
        }
      }
      `, {
      trancheId
    });
    return $query.pipe(map4((data) => {
      if (!data) {
        return [];
      }
      return data.trancheSnapshots.nodes.map((state) => {
        return __spreadProps(__spreadValues({}, state), {
          price: new Price(state.price)
        });
      });
    }));
  }
  function getNativeCurrency() {
    return inst.getApi().pipe(map4((api) => ({
      decimals: api.registry.chainDecimals[0],
      symbol: api.registry.chainTokens[0]
    })));
  }
  function getBalances(args) {
    const [address] = args;
    const $api = inst.getApi();
    const $events = inst.getEvents();
    return $api.pipe(switchMap3((api) => combineLatest3([
      api.query.ormlTokens.accounts.entries(address),
      api.query.system.account(address),
      api.query.pools.pool.entries()
    ]), (api, [rawBalances, nativeBalance, poolValues]) => ({ api, rawBalances, nativeBalance, poolValues })), take3(1), map4(({ api, rawBalances, nativeBalance, poolValues }) => {
      const balances = {
        tranches: [],
        currencies: [],
        native: {
          balance: new BN5(nativeBalance.data.free.toString()),
          decimals: api.registry.chainDecimals[0],
          symbol: api.registry.chainTokens[0]
        }
      };
      const decimalsByPool = Object.fromEntries(poolValues.map(([k, v]) => [formatPoolKey(k), getCurrencyDecimals(v.toJSON().currency)]));
      rawBalances.forEach(([rawKey, rawValue]) => {
        const key = rawKey.toHuman()[1];
        const value = rawValue.toJSON();
        if (typeof key === "string") {
          const currency = key.toLowerCase();
          const currencyDecimals = currency.endsWith("usd") ? 12 : 18;
          balances.currencies.push({
            currency,
            balance: new CurrencyBalance(hexToBN(value.free), currencyDecimals),
            currencyDecimals
          });
        } else if ("Tranche" in key) {
          const [pid, trancheId] = key.Tranche;
          const poolId = pid.replace(/\D/g, "");
          if (value.free !== 0) {
            balances.tranches.push({
              poolId,
              trancheId,
              balance: new TokenBalance(hexToBN(value.free), decimalsByPool[poolId.replace(/\D/g, "")])
            });
          }
        } else {
          if (value.free !== 0) {
            const currency = key.Permissioned.toLowerCase();
            balances.currencies.push({
              currency,
              balance: new CurrencyBalance(hexToBN(value.free), 18),
              currencyDecimals: 18
            });
          }
        }
      });
      return balances;
    }), repeatWhen2(() => $events));
  }
  function getOrder(args) {
    const [address, poolId, trancheId] = args;
    const $api = inst.getApi();
    return $api.pipe(switchMap3((api) => combineLatest3([api.query.pools.order(trancheId, address), api.query.pools.pool(poolId).pipe(take3(1))])), map4(([orderValue, poolValue]) => {
      const order = orderValue.toJSON();
      const pool = poolValue.toJSON();
      const currency = getCurrency(pool.currency);
      const currencyDecimals = getCurrencyDecimals(pool.currency);
      if (!order) {
        return {
          currency,
          invest: new CurrencyBalance(0, currencyDecimals),
          redeem: new TokenBalance(0, currencyDecimals),
          epoch: 0
        };
      }
      return {
        currency,
        invest: new CurrencyBalance(hexToBN(order.invest), currencyDecimals),
        redeem: new TokenBalance(hexToBN(order.redeem), currencyDecimals),
        epoch: order.epoch
      };
    }));
  }
  function getLoans(args) {
    const [poolId] = args;
    const $api = inst.getApi();
    const $events = inst.getEvents().pipe(filter3(({ api, events }) => {
      const event = events.find(({ event: event2 }) => api.events.loans.Created.is(event2) || api.events.loans.Closed.is(event2) || api.events.loans.Priced.is(event2) || api.events.loans.Borrowed.is(event2) || api.events.loans.Repaid.is(event2) || api.events.loans.NAVUpdated.is(event2));
      return !!event;
    }));
    return $api.pipe(switchMap3((api) => combineLatest3([api.query.loans.activeLoans(poolId), api.query.pools.pool(poolId)]).pipe(take3(1)), (api, [activeLoanValues, poolValue]) => ({ api, activeLoanValues, poolValue })), switchMap3(({ api, activeLoanValues, poolValue }) => {
      const activeLoanData = activeLoanValues.toJSON();
      const interestAccrualKeys = activeLoanData.map((activeLoan) => hexToBN(activeLoan.interestRatePerSec));
      const $interestAccrual = api.query.interestAccrual.rate.multi(interestAccrualKeys).pipe(take3(1));
      const $interestLastUpdated = api.query.interestAccrual.lastUpdated();
      return combineLatest3([
        api.query.loans.loan.entries(poolId),
        of2(activeLoanValues),
        api.query.loans.closedLoans.entries(poolId),
        $interestAccrual,
        $interestLastUpdated,
        of2(poolValue)
      ]);
    }), map4(([loanValues, activeLoanValues, closedLoansValues, interestAccrual, interestLastUpdated, poolValue]) => {
      const pool = poolValue.toJSON();
      const currencyDecimals = getCurrencyDecimals(pool.currency);
      const loans = loanValues.map(([key, value]) => {
        const loan = value.toJSON();
        const [collectionId, nftId] = loan.collateral;
        return {
          id: formatLoanKey(key),
          poolId,
          status: getLoanStatus(loan),
          asset: {
            collectionId: collectionId.toString(),
            nftId: nftId.toString()
          }
        };
      });
      const activeLoanData = activeLoanValues.toJSON();
      const activeLoans = activeLoanData.reduce((prev, activeLoan, index) => {
        const interestData = interestAccrual[index].toJSON();
        const mapped = {
          id: String(activeLoan.loanId),
          poolId,
          interestRatePerSec: new Rate(hexToBN(activeLoan.interestRatePerSec)),
          outstandingDebt: getOutstandingDebt(activeLoan, currencyDecimals, interestLastUpdated.toJSON(), interestData == null ? void 0 : interestData.accumulatedRate),
          normalizedDebt: new CurrencyBalance(hexToBN(activeLoan.normalizedDebt), currencyDecimals),
          totalBorrowed: new CurrencyBalance(hexToBN(activeLoan.totalBorrowed), currencyDecimals),
          totalRepaid: new CurrencyBalance(hexToBN(activeLoan.totalRepaid), currencyDecimals),
          lastUpdated: new Date(activeLoan.lastUpdated * 1e3).toISOString(),
          originationDate: activeLoan.originationDate ? new Date(activeLoan.originationDate * 1e3).toISOString() : "",
          loanInfo: getLoanInfo(activeLoan.loanType, currencyDecimals),
          adminWrittenOff: activeLoan.adminWrittenOff,
          writeOffStatus: activeLoan.writeOffStatus
        };
        return __spreadProps(__spreadValues({}, prev), { [String(activeLoan.loanId)]: mapped });
      }, {});
      const closedLoans = closedLoansValues.reduce((prev, [key, value]) => {
        const closedLoan = value.toJSON();
        const loanId = formatLoanKey(key);
        const loan = {
          id: loanId,
          poolId,
          interestRatePerSec: new Rate(hexToBN(closedLoan.interestRatePerSec)),
          outstandingDebt: new CurrencyBalance(0, currencyDecimals),
          normalizedDebt: new CurrencyBalance(hexToBN(closedLoan.normalizedDebt), currencyDecimals),
          totalBorrowed: new CurrencyBalance(hexToBN(closedLoan.totalBorrowed), currencyDecimals),
          totalRepaid: new CurrencyBalance(hexToBN(closedLoan.totalRepaid), currencyDecimals),
          lastUpdated: new Date(closedLoan.lastUpdated * 1e3).toISOString(),
          originationDate: new Date(closedLoan.originationDate * 1e3).toISOString(),
          loanInfo: getLoanInfo(closedLoan.loanType, currencyDecimals),
          writeOffStatus: closedLoan.writeOffStatus
        };
        return __spreadProps(__spreadValues({}, prev), { [loanId]: loan });
      }, {});
      return loans.map((loan) => __spreadValues(__spreadValues(__spreadValues({}, loan), activeLoans[loan.id]), closedLoans[loan.id]));
    }), repeatWhen2(() => $events));
  }
  function getWriteOffGroups(args) {
    const [poolId] = args;
    const $api = inst.getApi();
    const $events = inst.getEvents().pipe(filter3(({ api, events }) => {
      const event = events.find(({ event: event2 }) => api.events.loans.WriteOffGroupAdded.is(event2));
      if (!event)
        return false;
      const [pid] = event.toHuman().event.data;
      return pid.replace(/\D/g, "") === poolId;
    }));
    return $api.pipe(switchMap3((api) => api.query.loans.poolWriteOffGroups(poolId)), map4((writeOffGroupsValues) => {
      const writeOffGroups = writeOffGroupsValues.toJSON();
      return writeOffGroups.map((g) => {
        return {
          overdueDays: g.overdueDays,
          penaltyInterestRate: new Rate(hexToBN(g.penaltyInterestRatePerSec)),
          percentage: new Rate(hexToBN(g.percentage))
        };
      });
    }), repeatWhen2(() => $events));
  }
  function getPendingCollect(args) {
    const [address, poolId, trancheId, executedEpoch] = args;
    const $api = inst.getApi();
    return $api.pipe(combineLatestWith2(getOrder([address, poolId, trancheId])), switchMap3(([api, order]) => {
      const currencyDecimals = getCurrencyDecimals(order.currency);
      if (order.epoch <= executedEpoch && order.epoch > 0 && (!order.invest.isZero() || !order.redeem.isZero())) {
        const epochKeys = Array.from({ length: executedEpoch + 1 - order.epoch }, (_, i) => [
          trancheId,
          order.epoch + i
        ]);
        const $epochs = api.query.pools.epoch.multi(epochKeys);
        return $epochs.pipe(map4((epochs) => {
          let payoutCurrencyAmount = new BN5(0);
          let payoutTokenAmount = new BN5(0);
          let remainingInvestCurrency = new BN5(order.invest);
          let remainingRedeemToken = new BN5(order.redeem);
          for (const epoch of epochs) {
            if (remainingInvestCurrency.isZero() && remainingRedeemToken.isZero())
              break;
            let { investFulfillment, redeemFulfillment, tokenPrice } = epoch.toJSON();
            investFulfillment = hexToBN(investFulfillment);
            redeemFulfillment = hexToBN(redeemFulfillment);
            tokenPrice = hexToBN(tokenPrice);
            if (!remainingInvestCurrency.isZero()) {
              const amount = remainingInvestCurrency.mul(investFulfillment).div(PerquintillBN);
              if (!amount.isZero()) {
                payoutTokenAmount = payoutTokenAmount.add(amount.mul(PriceBN).div(tokenPrice));
                remainingInvestCurrency = remainingInvestCurrency.sub(amount);
              }
            }
            if (!remainingRedeemToken.isZero()) {
              const amount = remainingRedeemToken.mul(redeemFulfillment).div(PerquintillBN);
              if (!amount.isZero()) {
                payoutCurrencyAmount = payoutCurrencyAmount.add(amount.mul(tokenPrice).div(PriceBN));
                remainingRedeemToken = remainingRedeemToken.sub(amount);
              }
            }
          }
          return {
            investCurrency: new CurrencyBalance(order.invest, currencyDecimals),
            redeemToken: new TokenBalance(order.redeem, currencyDecimals),
            epoch: order.epoch,
            payoutCurrencyAmount: new CurrencyBalance(payoutCurrencyAmount, currencyDecimals),
            payoutTokenAmount: new TokenBalance(payoutTokenAmount, currencyDecimals),
            remainingInvestCurrency: new CurrencyBalance(remainingInvestCurrency, currencyDecimals),
            remainingRedeemToken: new TokenBalance(remainingRedeemToken, currencyDecimals)
          };
        }));
      }
      return of2({
        investCurrency: new CurrencyBalance(order.invest, currencyDecimals),
        redeemToken: new TokenBalance(order.redeem, currencyDecimals),
        epoch: order.epoch,
        payoutCurrencyAmount: new CurrencyBalance(0, currencyDecimals),
        payoutTokenAmount: new TokenBalance(0, currencyDecimals),
        remainingInvestCurrency: new CurrencyBalance(order.invest, currencyDecimals),
        remainingRedeemToken: new TokenBalance(order.redeem, currencyDecimals)
      });
    }));
  }
  function getLoan(args) {
    const [poolId, loanId] = args;
    return getLoans([poolId]).pipe(map4((loans) => {
      const loanByLoanId = loans.find((loan) => loan.id === loanId);
      return loanByLoanId;
    }));
  }
  function getLoanCollectionIdForPool(args) {
    const [poolId] = args;
    const $api = inst.getApi();
    return $api.pipe(switchMap3((api) => api.query.loans.poolToLoanNftClass(poolId)), map4((result) => {
      const collectionId = result.toHuman().replace(/\D/g, "");
      return collectionId;
    }), take3(1));
  }
  function addWriteOffGroups(args, options) {
    const [poolId, writeOffGroups] = args;
    const $api = inst.getApi();
    return $api.pipe(switchMap3((api) => {
      const submittable = api.tx.utility.batchAll(writeOffGroups.map((g) => api.tx.loans.addWriteOffGroup(poolId, {
        percentage: g.percentage.toString(),
        overdueDays: g.overdueDays,
        penaltyInterestRatePerSec: g.penaltyInterestRate.toString()
      })));
      return inst.wrapSignAndSend(api, submittable, options);
    }));
  }
  function adminWriteOff(args, options) {
    const [poolId, loanId, writeOffGroupId] = args;
    const $api = inst.getApi();
    return $api.pipe(switchMap3((api) => {
      const submittable = api.tx.loans.adminWriteOff(poolId, loanId, writeOffGroupId);
      return inst.wrapSignAndSend(api, submittable, options);
    }));
  }
  function getAvailablePoolId() {
    return __async(this, null, function* () {
      const $api = inst.getApi();
      try {
        const res = yield firstValueFrom3($api.pipe(map4((api) => ({
          api,
          id: null,
          triesLeft: MAX_ATTEMPTS2
        })), expand2(({ api, triesLeft }) => {
          const id = String(getRandomUint());
          if (triesLeft <= 0)
            return EMPTY2;
          return api.query.pools.pool(id).pipe(map4((res2) => ({ api, id: res2.toJSON() === null ? id : null, triesLeft: triesLeft - 1 })), take3(1));
        }), filter3(({ id }) => !!id)));
        return res.id;
      } catch (e) {
        throw new Error(`Could not find an available pool ID in ${MAX_ATTEMPTS2} attempts`);
      }
    });
  }
  return {
    createPool,
    updatePool,
    setMaxReserve,
    setMetadata,
    updateInvestOrder,
    updateRedeemOrder,
    collect,
    closeEpoch,
    executeEpoch,
    submitSolution,
    getUserPermissions,
    getPoolPermissions,
    updatePoolRoles,
    getNextLoanId,
    createLoan,
    priceLoan,
    financeLoan,
    repayLoanPartially,
    repayAndCloseLoan,
    closeLoan,
    getPools,
    getBalances,
    getOrder,
    getLoans,
    getPendingCollect,
    getWriteOffGroups,
    addWriteOffGroups,
    adminWriteOff,
    getLoanCollectionIdForPool,
    getAvailablePoolId,
    getDailyPoolStates,
    getNativeCurrency,
    getDailyTrancheStates
  };
}
function hexToBN(value) {
  if (typeof value === "number")
    return new BN5(value);
  return new BN5(value.toString().substring(2), "hex");
}
function getCurrency(data) {
  if (!data)
    return "";
  if (typeof data === "string")
    return data.toLowerCase();
  const cur = "permissioned" in data ? data.permissioned : Object.keys(data)[0];
  return cur.toLowerCase();
}
function getCurrencyDecimals(data) {
  const currency = getCurrency(data);
  return currency.endsWith("usd") ? 12 : 18;
}
function getLoanInfo(loanType, currencyDecimals) {
  if (loanType.bulletLoan) {
    return {
      type: "BulletLoan",
      advanceRate: new Rate(hexToBN(loanType.bulletLoan.advanceRate)),
      probabilityOfDefault: new Rate(hexToBN(loanType.bulletLoan.probabilityOfDefault)),
      lossGivenDefault: new Rate(hexToBN(loanType.bulletLoan.lossGivenDefault)),
      value: new CurrencyBalance(hexToBN(loanType.bulletLoan.value), currencyDecimals),
      discountRate: new Rate(hexToBN(loanType.bulletLoan.discountRate)),
      maturityDate: new Date(loanType.bulletLoan.maturityDate * 1e3).toISOString()
    };
  }
  if (loanType.creditLine) {
    return {
      type: "CreditLine",
      advanceRate: new Rate(hexToBN(loanType.creditLine.advanceRate)),
      value: new CurrencyBalance(hexToBN(loanType.creditLine.value), currencyDecimals)
    };
  }
  if (loanType.creditLineWithMaturity) {
    return {
      type: "CreditLineWithMaturity",
      advanceRate: new Rate(hexToBN(loanType.creditLineWithMaturity.advanceRate)),
      probabilityOfDefault: new Rate(hexToBN(loanType.creditLineWithMaturity.probabilityOfDefault)),
      value: new CurrencyBalance(hexToBN(loanType.creditLineWithMaturity.value), currencyDecimals),
      discountRate: new Rate(hexToBN(loanType.creditLineWithMaturity.discountRate)),
      maturityDate: new Date(loanType.creditLineWithMaturity.maturityDate * 1e3).toISOString(),
      lossGivenDefault: new Rate(hexToBN(loanType.creditLineWithMaturity.lossGivenDefault))
    };
  }
  throw new Error(`Unrecognized loan info: ${JSON.stringify(loanType)}`);
}
function getOutstandingDebt(loan, currencyDecimals, lastUpdated, accumulatedRate) {
  if (!accumulatedRate)
    return new CurrencyBalance(0, currencyDecimals);
  const accRate = new Rate(hexToBN(accumulatedRate)).toDecimal();
  const rate = new Rate(hexToBN(loan.interestRatePerSec)).toDecimal();
  const normalizedDebt = new CurrencyBalance(hexToBN(loan.normalizedDebt), currencyDecimals).toDecimal();
  const secondsSinceUpdated = Date.now() / 1e3 - lastUpdated;
  const debtFromAccRate = normalizedDebt.mul(accRate);
  const debtSinceUpdated = normalizedDebt.mul(rate.minus(1).mul(secondsSinceUpdated));
  const debt = debtFromAccRate.add(debtSinceUpdated);
  return CurrencyBalance.fromFloat(debt, currencyDecimals);
}
var getLoanStatus = (loanValue) => {
  const status = Object.keys(loanValue.status)[0];
  return `${status.charAt(0).toUpperCase()}${status.slice(1)}`;
};
var computeTrancheId = (trancheIndex, poolId) => {
  const a = new BN5(trancheIndex).toArray("le", 8);
  const b = new BN5(poolId).toArray("le", 8);
  const data = Uint8Array.from(a.concat(b));
  return toHex((0, import_blake2b.hash)(data, 16));
};
function toHex(data) {
  const hex = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f"];
  const out = [];
  for (let i = 0; i < data.length; i++) {
    out.push(hex[data[i] >> 4 & 15]);
    out.push(hex[data[i] & 15]);
  }
  return `0x${out.join("")}`;
}
var getEpochStatus = (epochExecution, blockNumber) => {
  if (!!epochExecution && !(epochExecution == null ? void 0 : epochExecution.challengePeriodEnd)) {
    return "submissionPeriod";
  } else if ((epochExecution == null ? void 0 : epochExecution.challengePeriodEnd) >= blockNumber) {
    return "challengePeriod";
  } else if ((epochExecution == null ? void 0 : epochExecution.challengePeriodEnd) < blockNumber) {
    return "executionPeriod";
  } else {
    return "ongoing";
  }
};

// src/modules/proxies.ts
import { encodeAddress } from "@polkadot/util-crypto";
import { map as map5 } from "rxjs/operators";
function getProxiesModule(inst) {
  function getUserProxies(args) {
    const [address] = args;
    const $query = inst.getSubqueryObservable(`query($address: String!) {
        proxies(filter: { delegatee: { equalTo: $address }}) {
          nodes {
            delegator
            proxyType
          }
        }
      }`, {
      address: encodeAddress(address, inst.getChainId())
    }, false);
    return $query.pipe(map5((data) => {
      const proxies = {};
      data == null ? void 0 : data.proxies.nodes.forEach((node) => {
        if (proxies[node.delegator]) {
          proxies[node.delegator].types.push(node.proxyType);
        } else {
          proxies[node.delegator] = {
            delegator: node.delegator,
            types: [node.proxyType]
          };
        }
      });
      return Object.values(proxies);
    }));
  }
  function getMultiUserProxies(args) {
    const [addresses] = args;
    const $query = inst.getSubqueryObservable(`query($addresses: [String!]) {
        proxies(filter: { delegatee: { in: $addresses }}) {
          nodes {
            id
            delegator
            delegatee
            proxyType
          }
        }
      }`, {
      addresses: addresses.map((addr) => encodeAddress(addr, inst.getChainId()))
    }, false);
    return $query.pipe(map5((data) => {
      const proxiesByUser = {};
      data == null ? void 0 : data.proxies.nodes.forEach((node) => {
        var _a;
        const index = (_a = proxiesByUser[node.delegatee]) == null ? void 0 : _a.findIndex((p) => p.delegator === node.delegator);
        if (index > -1) {
          proxiesByUser[node.delegatee][index].types.push(node.proxyType);
        } else {
          ;
          (proxiesByUser[node.delegatee] || (proxiesByUser[node.delegatee] = [])).push({
            delegator: node.delegator,
            types: [node.proxyType]
          });
        }
      });
      return proxiesByUser;
    }));
  }
  return {
    getUserProxies,
    getMultiUserProxies
  };
}

// src/modules/tokens.ts
import { switchMap as switchMap4 } from "rxjs";
function getTokensModule(inst) {
  function transfer(args) {
    const $api = inst.getApi();
    return $api.pipe(switchMap4((api) => {
      const submittable = api.tx.tokens.transfer(...args);
      return inst.wrapSignAndSend(api, submittable);
    }));
  }
  return {
    transfer
  };
}

// src/modules/utils.ts
import { encodeAddress as encodeAddress2 } from "@polkadot/util-crypto";
import { combineLatest as combineLatest4, map as map6, switchMap as switchMap5, take as take4 } from "rxjs";
var RANGE_FOR_BLOCKTIME_AVG = 10;
function getUtilsModule(inst) {
  function formatAddress(address) {
    return encodeAddress2(address, inst.getChainId());
  }
  function getAvgTimePerBlock() {
    const $currentBlock = inst.getBlocks().pipe(take4(1));
    const $prevBlock = $currentBlock.pipe(switchMap5((currentBlock) => {
      const blockNumber = currentBlock.block.header.number.toNumber();
      return inst.getBlockByBlockNumber(blockNumber - RANGE_FOR_BLOCKTIME_AVG);
    }));
    return combineLatest4([$currentBlock, $prevBlock]).pipe(map6(([currentBlock, prevBlock]) => {
      const tCurrent = new Date((currentBlock == null ? void 0 : currentBlock.block.extrinsics[1].args[0]).unwrap().toNumber()).getTime();
      const tPrev = new Date((prevBlock == null ? void 0 : prevBlock.block.extrinsics[1].args[0]).unwrap().toNumber()).getTime();
      return (tCurrent - tPrev) / RANGE_FOR_BLOCKTIME_AVG;
    }));
  }
  return __spreadProps(__spreadValues({}, utils_exports), {
    formatAddress,
    getAvgTimePerBlock
  });
}

// src/Centrifuge.ts
var Centrifuge = class extends CentrifugeBase {
  constructor(config = {}) {
    super(config);
    this.nfts = getNftsModule(this);
    this.pools = getPoolsModule(this);
    this.utils = getUtilsModule(this);
    this.proxies = getProxiesModule(this);
    this.metadata = getMetadataModule(this);
    this.tokens = getTokensModule(this);
  }
  connect(address, signer) {
    return new Centrifuge(__spreadProps(__spreadValues({}, this.config), { signer, signingAddress: address }));
  }
};

// src/utils/solver/index.ts
import BN6 from "bn.js";
var calculateOptimalSolution = (state, orders, weights, calcInvestmentCapacityForTranche) => __async(void 0, null, function* () {
  const res = yield import("clp-wasm/clp-wasm.all");
  const clp = yield res.default;
  if (state.tranches.length !== orders.length || orders.length !== weights.length) {
    throw new Error("Mismatched input length");
  }
  if (state.tranches.length === 0 || state.tranches[0].minRiskBuffer !== null) {
    throw new Error("Missing junior tranche");
  }
  if (!state.tranches.slice(1).every((tranche) => !!tranche.minRiskBuffer)) {
    throw new Error("Missing min risk buffer for non junior tranche");
  }
  if (!state.tranches.every((tranche) => !!tranche.ratio)) {
    throw new Error("Missing ratio for tranche");
  }
  if (calcInvestmentCapacityForTranche !== void 0 && state.tranches.length < calcInvestmentCapacityForTranche) {
    throw new Error("Trying to calculate investment capacity for an invalid tranche");
  }
  const varWeights = weights.map((tranche) => [parseFloat(tranche.invest.toString()), parseFloat(tranche.redeem.toString())]).flat();
  const varNames = weights.map((_t, index) => [`tranche-${index}-invest`, `tranche-${index}-redeem`]).flat();
  const bounds = orders.map((order, index) => [
    `0 <= tranche-${index}-invest  <= ${order.invest}
`,
    `0 <= tranche-${index}-redeem  <= ${order.redeem}
`
  ]).flat().join().replaceAll(",", "");
  const coefs = Array(state.tranches.length).fill([1, -1]).flat();
  const lp = `
      Maximize
        ${linearExpression(varNames, varWeights)}
      Subject To
        reserve: ${linearExpression(varNames, coefs)} >= ${state.reserve.neg()}
        maxReserve: ${linearExpression(varNames, coefs)} <= ${state.maxReserve.sub(state.reserve)}
      Bounds
        ${bounds}
      End
    `;
  const output = clp.solve(lp, 0);
  const solutionVector = output.solution.map((x) => new BN6(clp.bnRound(x)));
  const isFeasible = output.infeasibilityRay.length === 0;
  if (!isFeasible) {
    return {
      isFeasible: false,
      tranches: state.tranches.map(() => {
        return {
          invest: {
            perquintill: Perquintill.fromFloat(0),
            amount: CurrencyBalance.fromFloat(0, state.currencyDecimals)
          },
          redeem: {
            perquintill: Perquintill.fromFloat(0),
            amount: CurrencyBalance.fromFloat(0, state.currencyDecimals)
          }
        };
      })
    };
  }
  return {
    isFeasible,
    tranches: state.tranches.map((_t, index) => {
      const investSolution = new CurrencyBalance(solutionVector[index * 2].toString(), state.currencyDecimals);
      const redeemSolution = new CurrencyBalance(solutionVector[index * 2 + 1].toString(), state.currencyDecimals);
      const investPerquintill = Perquintill.fromFloat(investSolution.gtn(0) ? investSolution.toDecimal().div(orders[index].invest.toDecimal()).toString() : 0);
      const redeemPerquintill = Perquintill.fromFloat(redeemSolution.gtn(0) ? redeemSolution.toDecimal().div(orders[index].redeem.toDecimal()).toString() : 0);
      return {
        invest: {
          perquintill: investPerquintill,
          amount: investSolution
        },
        redeem: {
          perquintill: redeemPerquintill,
          amount: redeemSolution
        }
      };
    })
  };
});
var nameValToStr = (name, coef, first2) => {
  const ONE = new BN6(1);
  const ZERO = new BN6(0);
  const coefBN = new BN6(coef);
  if (coefBN.eq(ZERO)) {
    return "";
  }
  let str = "";
  if (first2 && coefBN.eq(ONE)) {
    return name;
  }
  if (coefBN.eq(ONE)) {
    str += "+";
  } else if (coefBN.eq(ONE.neg())) {
    str += "-";
  } else {
    str += (coefBN.gt(ZERO) ? "+" : "") + coefBN.toString();
  }
  str += ` ${name}`;
  return str;
};
var linearExpression = (varNames, coefs) => {
  let str = "";
  let first2 = true;
  for (let i = 0; i < varNames.length; i += 1) {
    str += `${nameValToStr(varNames[i], coefs[i], first2)} `;
    first2 = false;
  }
  return str;
};

// src/index.ts
var src_default = Centrifuge;
export {
  CurrencyBalance,
  LoanStatus,
  Perquintill,
  Price,
  Rate,
  TokenBalance,
  addThousandsSeparators,
  aprToFee,
  baseToDisplay,
  calculateOptimalSolution,
  src_default as default,
  feeToApr,
  formatCurrencyAmount,
  formatPercentage,
  formatRatio,
  getRandomUint,
  isLoanPalletAccount,
  isSameAddress,
  toPerquintill,
  toPrecision
};
//# sourceMappingURL=centrifuge-js.esm.js.map
